import React, { ReactNode } from "react";

import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList'
import ListItemIcon from '@mui/material/ListItemIcon';
import { Unstable_NumberInput as NumberInput } from '@mui/base/Unstable_NumberInput';

import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import { AppBar, Box, FormControl, InputLabel, Switch, Toolbar, Typography, Checkbox } from '@mui/material';
import { Select, NativeSelect } from '@mui/material';
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import makeStyles from '@mui/styles/makeStyles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
//import cardStyles from "assets/jss/material-dashboard-react/components/customTabsStyle.js";

//Moment date/time formatting
//https://momentjs.com/docs/
import moment, { Moment } from 'moment';
import TooltipMaterial from '@mui/material/Tooltip';
import DateAdapter from '@mui/lab/AdapterMoment';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import TimePicker from '@mui/lab/TimePicker';
import DateTimePicker from '@mui/lab/DateTimePicker';
import NumericInput from 'react-numeric-input';
import Modal from 'react-bootstrap/Modal'

import { NotificationContainer, NotificationManager } from 'react-notifications';

import { withStyles, createStyles } from '@mui/styles';
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

import { CreateUrl, CallGetAPI, CallPutAPI, CallPostAPI, CallDeleteAPI } from 'Utils/ApiHelper.js';
import { APIPhoneNumber } from "models/APIPhoneNumber"
import { APIGprsDetail } from "models/APIGprsDetail"
import { APISimDetail } from "models/APISimDetail"
import { APIConfigTemplate } from "models/APIConfigTemplate"
import { ChariotConfig, ChariotAlarm, configFromJson, jsonFromConfig } from "models/ChariotConfig"

import SampleRate from './SampleRate';
import WindowPeriod from './WindowPeriod';
import WebMapView from '../Map/WebMapView';
import GoogleMapsGPSSet from '../Map/GoogleMapsGPSSet'
//DevExtreme data grid
import 'devextreme/dist/css/dx.light.css';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import DataGrid, { Column, Editing, Selection } from 'devextreme-react/data-grid';
import SelectBox from 'devextreme-react/select-box';
import nbiot from '../../assets/nbiot_green_rgb.png'
import lte from '../../assets/lte_m_rgb.png'
import Login from "../api-authorization/Login";
import {  GutermannModelDeConverter } from "../../Utils/GutermannModelCoverter";
import { unit } from "esri/layers/support/VoxelVariable";
import { injectIntl, FormattedMessage, IntlShape } from 'react-intl';
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";
import {pressureConverter, flowConverter, totalConverter } from '../../Utils/UnitConverters'
import { enumChariotAlarmInput } from '../../models/enumChariotAlarmInput'

import * as semver from 'semver';
import {inputUnits } from '../../Utils/CurrentInputUnits'

const style = createStyles(styles as Record<string, any>);


interface Props {
    classes: {
        cardTitleWhite: string;
    };
    serial: string;
    product: string;
    model: string;
    channels: number;
    meterConfig: number;
    onConfigSend?: (deviceConfig: string) => void;
    intl: IntlShape;
}

interface State {
    orgConfig?: ChariotConfig;
    deviceConfig?: ChariotConfig;
    ready: boolean;
    openViewMenu: boolean;
    openTemplateMenu: boolean;
    enableSend: boolean;
    anchorEl: Element | null;
    panel: string;
    simDetails: DataSource;
    gprsDetails: DataSource;
    phoneNumbers: DataSource;
    templates: Array<APIConfigTemplate>;
    simEdit: number | null;
    gprsEdit: number | null;
    phoneEdit: number | null;
    templateName: string;
    templateSelect: number;
    templateNameError: boolean;
    templateNameErrorMsg: string;
    smsTxTime: Date;
    meterConfig: number;
    channelsAvail: number;
    configDate?: Date;
    battery?: number;
    loggerHold: boolean;
    sendAfter: Date | null;
    modbusModal: boolean;
    modbusModalTitle: string;
    editAlarm?: ChariotAlarm;
    alarmTab: number;
    alarms: Array<ChariotAlarm>;
    setUnits: string;
    clrUnits: string;
    // Field error flags
    fieldErrors: {
        FlowAMultiplier: boolean;
        FlowBMultiplier: boolean;
        AnalogueCMultiplier: boolean;
        AnalogueDMultiplier: boolean;
        SetThreshold: boolean;
        ClrThreshold: boolean;
        SetCount: boolean;
        ClrCount: boolean;
        MaxAlarms: boolean;
    };
    transducer1: number | null;
    transducer2: number | null;
    tempAlarmUnits: string | null;
    lastConfigUser: string | null;
    dormant: boolean
    confirmText: string
    allowConfig: boolean
    batteryReset: boolean
    configMessageRequest: boolean
    statusMessageRequest: boolean
    sigCheckRequest: boolean
    typeOfUpdate: string
    minInterval: number
}

const schedules = ['FlowASchedule', 'FlowBSchedule', 'AnalogueCSchedule', 'AnalogueDSchedule']
class ToolkitCHR extends React.Component<Props, State> {
    notificationSystem = React.createRef();

    constructor(props: Readonly<Props>) {
        super(props);
        locale(sessionStorage.getItem('language'));
        loadMessages(frMessages);
        loadMessages(deMessages);
        loadMessages(esMessages);
        loadMessages(ptMessages);
        this.state = {
            orgConfig: undefined,
            deviceConfig: undefined,
            ready: false,
            openViewMenu: false,
            openTemplateMenu: false,
            enableSend: false,
            anchorEl: null,
            panel: "Config",
            simDetails: new DataSource({ store: { type: "array", key: "id", data: [] } }),
            gprsDetails: new DataSource({ store: { type: "array", key: "id", data: [] } }),
            phoneNumbers: new DataSource({ store: { type: "array", key: "id", data: [] } }),
            templates: [],
            simEdit: null,
            gprsEdit: null,
            phoneEdit: null,
            templateName: "",
            templateSelect: 0,
            templateNameError: false,
            templateNameErrorMsg: "",
            smsTxTime: new Date(),
            meterConfig: props.meterConfig,
            channelsAvail: props.channels ? props.channels : 0,
            configDate: undefined,
            battery: undefined,
            alarmTab: 0,
            loggerHold: false,
            sendAfter: null,
            modbusModal: false,
            modbusModalTitle: "",
            alarms: [],
            setUnits: "",
            clrUnits: "",
            fieldErrors: {
                FlowAMultiplier: false,
                FlowBMultiplier: false,
                AnalogueCMultiplier: false,
                AnalogueDMultiplier: false,
                SetThreshold: false,
                ClrThreshold: false,
                SetCount: false,
                ClrCount: false,
                MaxAlarms: false,
            },
            transducer1: null,
            transducer2: null,
            tempAlarmUnits: "",
            lastConfigUser: "",
            dormant: false,
            confirmText: "",
            allowConfig: true,
            batteryReset: false,
            configMessageRequest: false,
            statusMessageRequest: false,
            sigCheckRequest: false,
            reducedMobility: false,
            freqBandB3: false,
            freqBandB20: false,
            typeOfUpdate: "",
            minInterval: 43200
        };

    }

    componentDidMount(): void {

        //get SimDetails, GprsDetails & PhoneNumbers
        //this.loadConfigTemplates();
        //this.loadSimDetails();
        //this.loadGprsDetails();
        // Load Alarm Configs
        this.loadAlarmConfigs();
        window.addEventListener("popstate", this.handlePopState);
        this.handleReadClick()
        
    }

    componentWillUnmount(): void {
        window.removeEventListener("popstate", this.handlePopState)
    }


    handlePopState(): void {
       // console.log('back button clicked')
    }

    loadSimDetails(): void {
        const me = this;

        CallGetAPI(CreateUrl('/api/aquaguard/SimDetailsForCompany?companyId=' + sessionStorage.getItem('companyId')), {})
            .then(data => {
                if (data.length > 0) {
                    const store = new ArrayStore(
                        {
                            key: "id",
                            data: data as APISimDetail[]
                        });

                    me.setState(
                        {
                            simDetails: new DataSource({ store: store }),
                        });
                }
                else {
                    console.log("No simDetails");
                }
            },
                // reject() - API error
                () => {
                    me.createLoadErrorNotification();
                    console.log("API Error");

                })
            .catch(function () {
                me.createLoadErrorNotification();
            });
    }

    loadGprsDetails(): void {

        const me = this;
        CallGetAPI(CreateUrl('/api/aquaguard/GprsDetailsForCompany?companyId=' + sessionStorage.getItem('companyId')), {})
            .then(data => {
                if (data.length > 0) {
                    const store = new ArrayStore(
                        {
                            key: "id",
                            data: data as APIGprsDetail[]
                        });

                    me.setState(
                        {
                            gprsDetails: new DataSource({ store: store }),
                        });
                }
                else {
                    console.log("No gprsDetails");
                }
            },
                // reject() - API error
                () => {
                    me.createLoadErrorNotification();
                    console.log("API Error");

                })
            .catch(function () {
                me.createLoadErrorNotification();
            });
    }



    loadTimeframe = (count: number, transInterval: number): string => {

        if (transInterval === 5) {
            if (count === 1) {
                return '5mins';
            } else if (count === 2) {
                return '10mins';
            } else if (count === 3) {
                return '15mins';
            } else if (count === 6) {
                return '30mins';
            } else if (count === 12) {
                return '1hour';
            } else if (count === 36) {
                return '3hour';
            } else if (count === 72) {
                return '6hour';
            } else if (count === 144) {
                return '12hour';
            } else if (count === 288) {
                return '24hour';
            }
        } else if (transInterval === 15) {
            if (count === 1) {
                return '15mins';
            } else if (count === 2) {
                return '30mins';
            } else if (count === 4) {
                return '1hour';
            } else if (count === 12) {
                return '3hour';
            } else if (count === 24) {
                return '6hour';
            } else if (count === 48) {
                return '12hour';
            } else if (count === 96) {
                return '24hour';
            }
        } else if (transInterval === 30) {
            if (count === 1) {
                return '30mins';
            } else if (count === 2) {
                return '1hour';
            } else if (count === 6) {
                return '3hour';
            } else if (count === 12) {
                return '6hour';
            } else if (count === 24) {
                return '12hour';
            } else if (count === 48) {
                return '24hour';
            }
        } else if (transInterval === 60) {
            if (count === 1) {
                return '1hour';
            } else if (count === 3) {
                return '3hour';
            } else if (count === 6) {
                return '6hour';
            } else if (count === 12) {
                return '12hour';
            } else if (count === 24) {
                return '24hour';
            }
        } else if (transInterval === 180) {
            if (count === 1) {
                return '3hour';
            } else if (count === 2) {
                return '6hour';
            } else if (count === 4) {
                return '12hour';
            } else if (count === 8) {
                return '24hour';
            }
        } else if (transInterval === 360) {
            if (count === 1) {
                return '6hour';
            } else if (count === 2) {
                return '12hour';
            } else if (count === 4) {
                return '24hour';
            }
        } else if (transInterval === 720) {
            if (count === 1) {
                return '12hour';
            } else if (count === 2) {
                return '24hour';
            }
        } else if (transInterval === 1440) {
            if (count === 1) {
                return '24hour';
            }
        }
        return '';
    };



    loadAlarmConfigs(): void {
        const me = this;

        CallGetAPI(CreateUrl('/api/aquaguard/LCAlarmConfigurations?serial=' + this.props.serial), {})
            .then((data) => {

                    const recs = new Array<ChariotAlarm>();
                    let alarmMask = 1;  // 16 bit mask for alarm channel
                    const loggerId = data[0].fkLCLoggerId;
                const interval = this.state.deviceConfig?.TransmissionInterval ? this.state.deviceConfig?.TransmissionInterval : 0;
                    for (let i = 1; i <= 16; i++) {
                        const alarmConfig: ChariotAlarm = {
                            Idx: i,
                            Id: 0,
                            AlarmMask: alarmMask,
                            AlarmMessage: "",
                            AlarmClass: 0,
                            SetInput: 0,
                            SetOperator: 0,
                            SetThreshold: 0,
                            SetThresholdStr: "0",
                            ClrInput: 0,
                            ClrOperator: 0,
                            ClrThreshold: 0,
                            ClrThresholdStr: "0",
                            SetCount: 0,
                            SetCountStr: "0",
                            ClrCount: 0,
                            ClrCountStr: "0",
                            MaxAlarms: 0,
                            MaxAlarmsStr: "0",
                            FkLCLoggerId: loggerId,
                            Unit: null
                        }

                        if (data.length > 0) {
                            data.map((a: any) => {

                                if (a.alarmMask == alarmMask) {
                                    alarmConfig.Id = a.id;
                                    alarmConfig.AlarmMessage = a.alarmMessage;
                                    alarmConfig.AlarmClass = a.alarmClass;
                                    alarmConfig.SetInput = a.setInput;
                                    alarmConfig.SetOperator = a.setOperator;
                                    alarmConfig.SetThreshold = a.setThreshold;
                                    alarmConfig.SetThresholdStr = a.setThreshold.toString();
                                    alarmConfig.ClrInput = a.clrInput;
                                    alarmConfig.ClrOperator = a.clrOperator;
                                    alarmConfig.ClrThreshold = a.clrThreshold;
                                    alarmConfig.ClrThresholdStr = a.clrThreshold.toString();
                                    alarmConfig.SetCount = a.setCount;
                                    alarmConfig.SetCountStr = this.loadTimeframe(a.setCount, interval);
                                    alarmConfig.ClrCount = a.clrCount;
                                    alarmConfig.ClrCountStr = this.loadTimeframe(a.clrCount, interval);
                                    alarmConfig.MaxAlarms = a.maxAlarms;
                                    alarmConfig.MaxAlarmsStr = a.maxAlarms.toString();
                                    alarmConfig.Unit = a.unit
                                }
                            });
                        }

                        recs.push(alarmConfig);

                        alarmMask = alarmMask << 1;
                    }

                    me.setState(
                        {
                            alarms: recs,
                        });
                },
                // reject() - API error
                () => {
                    me.createLoadErrorNotification();
                    console.log("API Error");

                })
            .catch(function () {
                me.createLoadErrorNotification();
            });

    }

    loadConfigTemplates(): void {
        const me = this;
        let model = this.props.model
        if (window.location.hostname.inlcudes('zonelog.net')) {
            model = GutermannModelDeConverter(model)
        }
        CallGetAPI(CreateUrl('/api/aquaguard/ConfigTemplatesForCompany?companyId=' + sessionStorage.getItem('companyId') + '&product=' + this.props.product + '&model=' + model), {})
            .then(data => {
                if (data.length > 0) {

                    me.setState(
                        {
                            templates: data as APIConfigTemplate[],
                        });
                }
                else {
                    console.log("No config templates");
                }
            },
                // reject() - API error
                () => {
                    me.createLoadErrorNotification();
                    console.log("API Error");

                })
            .catch(function (error) {
                console.log(error);
                me.createLoadErrorNotification();
            });
    }

    createSuccessNotification = (msg: string): void => {
        NotificationManager.success(msg, this.props.intl.formatMessage({ id: 'Success' }));
 
    };

    createErrorNotification = (type: string): void => {
        NotificationManager.error(this.props.intl.formatMessage({ id: 'Error Saving ' }) + type, this.props.intl.formatMessage({ id: 'Contact Administrator' }), 5000, () => {
            alert(this.props.intl.formatMessage({ id: 'Contact Administrator' }));
        });
    };

    createLoadErrorNotification = (): void => {
        NotificationManager.error(this.props.intl.formatMessage({ id: 'Error Loading config data ' }), this.props.intl.formatMessage({ id: 'Contact Administrator' }), 5000, () => {
            alert(this.props.intl.formatMessage({ id: 'Contact Administrator' }));
        });
    };


    //save changes, for both edit and new
    saveConfig = (): void => {
     
            //********************
            //send config update to API

            const me = this;

        const changes = {}
        for (const key in this.state.orgConfig) {
            if (this.state.orgConfig[key] !== this.state.deviceConfig[key]) {
                if (key.includes('MapMin') || key.includes('MapMax')) {
                    changes[key] = this.state.deviceConfig[key]
                    changes[`${key}Original`] = this.state.orgConfig[key]
                    changes[`${key.slice(0, 9)}Units`] = this.state.deviceConfig?.[`${key.slice(0, 9)}Units`]
                } else {
                    changes[key] = this.state.deviceConfig[key]
                    changes[`${key}Original`] = this.state.orgConfig[key]
                }
            }
        }
        
            const updateJson = jsonFromConfig(this.state.orgConfig,
                this.state.deviceConfig
            );
            if (updateJson != "{}") {

                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ serial: me.props.serial, updateJson: updateJson, sendConfigAfter: this.state.sendAfter, isChariot: true })
                };

                CallPostAPI(CreateUrl('/api/Aquaguard/LoggerConfigurations'), requestOptions)
                    .then(response => {

                        if (response.ok) {
                            CallPostAPI(CreateUrl(`/api/aquaguard/audit?serial=${me.props.serial}&type=CONFIG&userGuid=${sessionStorage.getItem('userGuid')}&details=${window.location.hostname.includes('zonelog.net') ? 'ZONELOG Config Update ' + JSON.stringify(changes) : 'Aquaguard Config Update ' + JSON.stringify(changes)}`), {})
                                .then(data => {
                                    if (data.status === 200) {
                                        CallGetAPI(CreateUrl('/api/aquaguard/audit?serial=' + this.props.serial + "&type=CONFIG"), {})
                                            .then(audit => {
 
                                                me.setState({ lastConfigUser: audit[0]?.email })
                                            })
                                    }
                                })
                                .catch(err => {
                                    me.setState({ lastConfigUser: 'Unknown' })
                                })

                            me.createSuccessNotification(this.props.intl.formatMessage({ id: 'Device will be updated on next connection' }));

                        }
                        else {
                            me.createErrorNotification(this.props.intl.formatMessage({ id: 'Error Saving Config updates' }));
                        }
                    })
                    .catch(function (error) {
                        me.createErrorNotification(this.props.intl.formatMessage({ id: 'Error Saving Config updates' }));
                        console.log(error);
                    });
            }
        

    }

    // Menu click handlers
    
    handleReadClick = (): void => {

        const me = this;

        CallGetAPI(CreateUrl('/api/aquaguard/CurrentLCLoggerConfiguration?serial=' + this.props.serial), {})
            .then(data => {


                if (data.status === undefined) {
                    const config = configFromJson(this.props.product, 
                        data, false
                    );

                    for (const key in config) {
                        
                        if (schedules.includes(key)) {
                            if (config[key] < this.state.minInterval && config[key] !== 0) {
                                this.setState({minInterval: config[key]})
                            }
                        }
                    }

                    me.setState(
                        {
                            orgConfig: JSON.parse(JSON.stringify(config)),   // Save DEEP CLONE of original
                            deviceConfig: config,
                            anchorEl: null,
                            ready: true,
                            enableSend: false,
                            configDate: data.startTime,
                            battery: data.readBatteryChannel / 1000,
                            channelsAvail: this.props.channels ? this.props.channels : 0,
                            transducer1: data.transducer1,
                            transducer2: data.transducer2
                        })
                    CallGetAPI(CreateUrl('/api/aquaguard/audit?serial=' + this.props.serial + "&type=CONFIG"), {})   
                        .then(audit => {

                            if (audit.length > 0) {
                                const cutChar = audit[0]?.details.indexOf('{')

                                const details = audit[0]?.details.slice(0, cutChar)
                                me.setState(
                                    {
                                        lastConfigUser: audit[0]?.email,
                                        typeOfUpdate: details
                                    });
                            }
})
                   

                }
            },
                // reject() - API error
                () => {
                    console.log("API Error");

                })
            .catch(function (error) {
                console.log(error);
            });

    }

    handleSendClick = (): void => {

        // Evaluate numeric fields
        const config = Object.assign({}, this.state.deviceConfig);
        if (!isNaN(parseFloat(config.FlowAMultiplierStr))) {
            config.FlowAMultiplier = parseFloat(config.FlowAMultiplierStr);
        }
        else {
            alert(this.props.intl.formatMessage({ id: "Please correct Flow Multiplier" }));
            return;
        }


        if (this.state.orgConfig?.FlowAMultiplier != config.FlowAMultiplier) {
            alert(this.props.intl.formatMessage({ id: "Warning, changing the Pulse Multiplier will affect the accuracy of the meter totaliser / meter read, please proceed with caution" }));
        }

        this.setState({ deviceConfig: config, panel: "Save Config"})
    }

    
    handleSendAfterClick = (): void => {
            if (this.state.deviceConfig) {
                if (this.props.onConfigSend) {
                    this.props.onConfigSend(jsonFromConfig(
                        this.state.orgConfig,
                        this.state.deviceConfig,
                    ));
                }
                else {
                    this.saveConfig();
                }
            }
            this.setState({ enableSend: false, panel: "Config" });
        
    }
    
    // Config Templates
    handleLoadTemplate = (): void => {

        const template = this.state.templates.filter((t) => t.id == this.state.templateSelect)[0];
        const deviceConfig: ChariotConfig = JSON.parse(template.configJson);

        if (this.state.deviceConfig) {
            deviceConfig.Sitename = this.state.deviceConfig.Sitename;
            deviceConfig.Latitude = this.state.deviceConfig.Latitude;
            deviceConfig.Longitude = this.state.deviceConfig.Longitude;
            deviceConfig.CurrentState = this.state.deviceConfig.CurrentState;
            deviceConfig.Guid = this.state.deviceConfig.Guid;
            deviceConfig.SWversion = this.state.deviceConfig.SWversion;
        }
        else {
            deviceConfig.Sitename = "";
            deviceConfig.Latitude = null;
            deviceConfig.Longitude = null;
            deviceConfig.CurrentState = "Unknown";
            deviceConfig.Guid = "";
            deviceConfig.SWversion = "";

        }

        this.setState({
            deviceConfig: deviceConfig,
            anchorEl: null,
            ready: true,
            enableSend: false,
            configDate: new Date(),
            battery: 0,
        });

        this.handleTemplateMenuClose();
    }

    handleSaveTemplate = (): void => {
        const me = this;
        const existing = this.state.templates.filter((t) => t.name == this.state.templateName);

        if (existing.length == 0) {
            const template: APIConfigTemplate = {
                id: 0,
                fkCompanyId: parseInt(sessionStorage.getItem('companyId') || "0"),
                name: this.state.templateName,
                product: this.props.product,
                model: this.props.model,
                lastUpdate: new Date(),
                configJson: JSON.stringify(this.state.deviceConfig)
            };
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(template)
            };

            CallGetAPI(CreateUrl('/api/Aquaguard/ConfigTemplate'), requestOptions)
                .then(data => {
                    if (data.status === undefined) {
                        template.id = data.id;
                        template.lastUpdate = data.lastUpdate;
                        const templates = me.state.templates;
                        templates.push(template);
                        me.setState({ templates: templates, templateSelect: template.id });

                        me.createSuccessNotification(this.props.intl.formatMessage({ id: "Config template saved" }));
                    }
                    else {
                        me.createErrorNotification(this.props.intl.formatMessage({ id: 'Error Saving Config template Changes' }));
                    }
                })
                .catch(function (error) {
                    me.createErrorNotification(this.props.intl.formatMessage({ id: 'Error Saving Config template Changes' }));
                    console.log(error);
                });
        }
        else {
            // Update existing template
            const template = existing[0];
            template.configJson = JSON.stringify(this.state.deviceConfig);

            const requestOptions = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(template)
            };

            CallGetAPI(CreateUrl('/api/Aquaguard/ConfigTemplate?id=' + template.id), requestOptions)
                .then(data => {
                    if (data.status === undefined) {
                        template.lastUpdate = data.lastUpdate;
                        const templates = me.state.templates;
                        templates.push(template);
                        me.setState({ templates: templates, templateSelect: template.id });

                        me.createSuccessNotification(this.props.intl.formatMessage({ id: "Config template updated" }));
                    }
                    else {
                        me.createErrorNotification(this.props.intl.formatMessage({ id: 'Error Saving Config template Changes' }));
                    }
                })
                .catch(function (error) {
                    me.createErrorNotification(this.props.intl.formatMessage({ id: 'Error Saving Config template Changes' }));
                    console.log(error);
                });
        }

        this.handleTemplateMenuClose();
    }

    // Menu handling
    handleViewClick = (event: any): void => {
        this.setState({
            openViewMenu: !this.state.openViewMenu,
            anchorEl: event.currentTarget
        });
    }
    handleTemplateClick = (event: any): void => {
        this.setState({
            openTemplateMenu: !this.state.openTemplateMenu,
            anchorEl: event.currentTarget
        });
    }

    showSimDetails = (): void => {
        this.setState({ openViewMenu: false, panel: "SIM Details" });
    }

    showGprsDetails = (): void => {
        this.setState({ openViewMenu: false, panel: "GPRS Details" });
    }

    showPhoneNumbers = (): void => {
        this.setState({ openViewMenu: false, panel: "Phone Numbers" });
    }
    showLoadTemplate = (): void => {
        this.setState({ openTemplateMenu: false, panel: "Load Template" });
    }
    showSaveTemplate = (): void => {
        this.setState({ openTemplateMenu: false, panel: "Save Template" });
    }

    handleViewMenuClose = (): void => {
        this.setState({ openViewMenu: false, anchorEl: null, panel: "Config" });
    }
    handleTemplateMenuClose = (): void => {
        this.setState({ openTemplateMenu: false, anchorEl: null, panel: "Config" });
    }

    // Field change handlers
    handleTextfieldChange = (e: any): void => {

        // Max text field lengths
        const maxLen = {
            Sitename: 25,
            FlowARef: 15,
            FlowBRef: 15,
            AnalogueCRef: 15,
            AnalogueDRef: 15,
            AnalogueCDp: 2,
            AnalogueDDp: 2,
            FlowAMultiplier: 7,
            FlowBMultiplier: 7,
            AnalogueCMultiplier: 7,
            AnalogueDMultiplier: 7,
            AnalogueCUnits: 2,
            AnalogueDUnits: 2
        };


        const inputName: string = e.target.name;
        const inputValue: string = e.target.value;

        const config = Object.assign({}, this.state.deviceConfig);
        const errors = this.state.fieldErrors;
        if (inputValue.length <= maxLen[inputName]) {
            if (inputName.endsWith("Multiplier")) {
                // NOTE parseFloat ignores any non-digits AFTER a number, so check last char is digit
                if (isNaN(parseFloat(inputValue)) || (inputValue.slice(-1) != "." && isNaN(parseFloat(inputValue.slice(-1))))) {
                    errors[inputName] = true;
                }
                else {
                    errors[inputName] = false;
                }

                config[inputName + "Str"] = inputValue;

            }
            else {
                if (inputName.endsWith("Dp")) {
                    if (!isNaN(parseInt(inputValue))) {
                        config[inputName] = inputValue;
                    }
                }
                else {
                    
                    config[inputName] = inputValue;
                }
            }
        } 
        this.setState({ deviceConfig: config, enableSend: true, fieldErrors: errors});

    }

    handleToggleChange = (e: any): void => {
        
        const inputName: string = e.target.name;
        const inputValue: boolean = e.target.checked;
        const config = Object.assign({}, this.state.deviceConfig);
        config[inputName] = inputValue;

        if (inputName == "FlowA" && inputValue) {
            // Default set Type, units & interval
            config.FlowAPulseType = 1;
            config.FlowAUnits = "01";
            config.FlowASchedule = 900;
        }
        if (inputName == "AnalogueC" && inputValue) {
            // Default set Type, units & interval
            config.AnalogueCUnits = "03";
            config.AnalogueCSchedule = 900;
        }
        if (inputName == "AnalogueD" && inputValue) {
            // Default set Type, units & interval
            config.AnalogueDUnits = "03";
            config.AnalogueDSchedule = 900;
        }
        if (inputName == "ReducedMobility" && inputValue) {
            config.ReducedMobility = true;
        }
        if (inputName == "FreqBandB3" && inputValue) {
            config.FreqBandB3 = true;
        }
        if (inputName == "FreqBandB20" && inputValue) {
            config.FreqBandB20 = true;
        }
        this.setState({ deviceConfig: config, enableSend: true, });

    }

    handleSelectChange = (e: any): void => {
        const inputName: string = e.target.name;
        const inputValue: string = e.target.value;

        const loggingToTransmission: Record<string, number> = {
            '5': 5,
            '10': 10,
            '15': 15,
            '30': 30,
            '60': 60,
            '300': 180,
            '600': 360,
            '900': 720,
            '1800': 1440,
            '3600': 1440,
            '10800': 1440,
            '21600': 1440,
            '28800': 1440,
            '43200': 1440
        }
        const config = Object.assign({}, this.state.deviceConfig);
        if (schedules.includes(inputName)) {
            this.setState({ minInterval: parseInt(inputValue) })
            if ((loggingToTransmission[inputValue] < this.state.minInterval) && (loggingToTransmission[inputValue] < config.TransmissionInterval)) {
                window.alert('The new logging interval is too fast for the current transmission interval - the transmission interval has been automatically changed to the slowest transmission for this setting')
                config.TransmissionInterval = loggingToTransmission[inputValue]
            }
        }
        if (typeof config[inputName] == 'number') {
            config[inputName] = parseInt(inputValue);
        }
        else {
            config[inputName] = inputValue;
        }
        
        
        this.setState({ deviceConfig: config, enableSend: true, });

    }

    handleFlowTypeChange = (e: any): void => {

        const inputName: string = e.target.name;
        const inputValue: string = e.target.value;
        const config = Object.assign({}, this.state.deviceConfig);
        config[inputName] = inputValue;

        this.setState({ deviceConfig: config, enableSend: true, });
    }
    handleNumericChange = (e:any): void => {
        const name = e.target.name
        const value = e.target.value
        const config = Object.assign({}, this.state.deviceConfig);
        config[name] = value
        this.setState({ deviceConfig: config, enableSend: true, });

    }


    handleTemplateChange = (e: any): void => {
        this.setState({ templateSelect: e.target.value, });
    }
    handleTemplateNameChange = (e: any): void => {
        const newName = e.target.value;
        if (newName.length < 50) {
            const existing = this.state.templates.filter((t) => t.name == newName);
            if (existing.length == 0) {
                this.setState({ templateName: newName, templateNameError: false, });
            }
            else {
                this.setState({
                    templateName: newName,
                    templateNameError: true,
                    templateNameErrorMsg: this.props.intl.formatMessage({ id: "Template exists - config will be updated" })
                });
            }
        }
        else {
            this.setState({ templateNameError: true, templateNameErrorMsg: this.props.intl.formatMessage({ id: "Too long - max 50 chars" }) })
        }
    }


    handleLoggerHold = (latitude: number, longitude: number): void => {

        // Check if hold is on logger spot
        if (Math.abs(latitude - (this.state.deviceConfig?.Latitude || 0)) < 0.001
            && Math.abs(longitude - (this.state.deviceConfig?.Longitude || 0)) < 0.001
        ) {
            this.setState({ loggerHold: true });
        }
    }

    handleLoggerHoldCancel = (): void => {
        this.setState({ loggerHold: false });
    }

    setLoggerLocation = (latitude: number, longitude: number): void => {
            const config = this.state.deviceConfig;
            if (config) {
                config.Latitude = latitude;
                config.Longitude = longitude;
                this.setState({ deviceConfig: config, enableSend: true, loggerHold: false });
            }
        

    }

   

    handleSendAfterChange = (e: Moment): void => {
        this.setState({ sendAfter: e.seconds(0).toDate() });
    }




     // Data Grid event & render handlers
    typeEditorRender = (cell: any): ReactNode => {
        const onValueChanged = this.onTypeChanged.bind(this, cell);
        return <SelectBox
            defaultValue={cell.value}
            dataSource={[
                { value: "Server" },
                { value: "User" }
            ]}
            valueExpr="value"
            displayExpr="value"
            onValueChanged={onValueChanged}
        />;
    }

    onTypeChanged = (cell: any, e: any): void => {
        cell.setValue(e.value);
    }

    // Display render functions
    makeDecimal(val: number | null | undefined): string {

        if (val) {
            if (isNaN(parseInt(val.toString()))) {
                return val + ".0";
            }
            else {
                return val.toFixed(3).toString();
            }
        }
        else {
            return "0.0";
        }
    }

    // Alarm settings
    chariotUnits = (val: string): string => {
        switch (val) {
            case "01":
                return this.props.intl.formatMessage({ id: "litres" });
            case "02":
                return "m3";
            case "03":
                return "bar";
            case "04":
                return "mb";
            case "05":
                return "mH2O";
            case "06":
                return "psi";
            default:
                return "";

        }
    }

    

    handleAlarmTextfieldChange = (e: any): void => {

        const inputName: string = e.target.name;
        const inputValue: string = e.target.value;
        const alarm = Object.assign({}, this.state.editAlarm);
        const errors = this.state.fieldErrors;
        if (inputName == "AlarmMessage") {
            if (inputValue.length <= 4000) {
                alarm[inputName] = inputValue;
            }
        }
        else {
            if (inputName.endsWith("Threshold")) {
                // Check it's decimal value
                // NOTE parseFloat ignores any non-digits AFTER a number, so check last char is digit
                if (isNaN(parseFloat(inputValue)) || (inputValue.slice(-1) != "." && isNaN(parseFloat(inputValue.slice(-1))))) {
                    errors[inputName] = true;
                }
                else {
                    errors[inputName] = false;
                }
                alarm[inputName + "Str"] = inputValue;

            }
            else {
                // Check it's integer value
                if (isNaN(parseInt(inputValue)) || inputValue.slice(-1) == "." || isNaN(parseInt(inputValue.slice(-1)))) {
                    errors[inputName] = true;
                }
                else {
                    errors[inputName] = false;
                }
                alarm[inputName + "Str"] = inputValue;
            }
        }
        this.setState({ editAlarm: alarm });

    };

    handleAlarmToggleChange = (e: any): void => {

        const inputName: string = e.target.name;
        const inputValue: boolean = e.target.checked;
        const alarm = Object.assign({}, this.state.editAlarm);
        alarm[inputName] = inputValue;

        this.setState({ editAlarm: alarm });

    };

    handleAlarmSelectChange = (e: any): void => {

        const inputName: string = e.target.name;
        const inputValue: string = e.target.value;
        const alarm = Object.assign({}, this.state.editAlarm);
        const tempAlarmUnits = "";
        if (inputName === 'SetCountStr' || inputName === 'ClrCountStr') {
            alarm[inputName] = inputValue;
        } else {
            alarm[inputName] = parseInt(inputValue);
        }
        let setUnits = this.state.setUnits;

        let clrUnits = this.state.clrUnits;

        // Copy Set input to Clr if Clr not set and set Units
        if (inputName.startsWith("SetInput")) {
            if (inputValue === "0" && this.state.deviceConfig?.FlowAUnits) {
                setUnits = this.chariotUnits("00")
            }
            if (inputValue == "1" && this.state.deviceConfig?.FlowAUnits) {
                setUnits = this.chariotUnits(this.state.deviceConfig?.FlowAUnits);
  
                if (setUnits === "litres") {
                    setUnits = "l/s";
                }
                else {
                    setUnits = "m3/h";
                }
            }

            if (inputValue == "2" && this.state.deviceConfig?.FlowAUnits) {
                setUnits = this.chariotUnits(this.state.deviceConfig?.FlowAUnits);
                if (setUnits === "litres") {
                    setUnits = "l/s";
                }
                else {
                    setUnits = "m3/h";
                }
            }
            if ((inputValue == "3" || inputValue == "11") && this.state.deviceConfig?.AnalogueCUnits) {
                setUnits = this.chariotUnits(this.state.deviceConfig?.AnalogueCUnits);
            }
            if ((inputValue == "7" || inputValue == "12") && this.state.deviceConfig?.AnalogueDUnits) {
                setUnits = this.chariotUnits(this.state.deviceConfig?.AnalogueDUnits);
            }
            if (inputValue == "30") {
                setUnits = "N/A";
            }
            if (inputValue == "31") {
                setUnits = "mV";
            }
            if (alarm.ClrInput == 0) {
                alarm.ClrInput = alarm.SetInput;
                clrUnits = setUnits;
            }
        }
        if (inputName.startsWith("ClrInput")) {
            if (inputValue === "0" && this.state.deviceConfig?.FlowAUnits) {
                clrUnits = this.chariotUnits("00")
            }
            if (inputValue == "1" && this.state.deviceConfig?.FlowAUnits) {
                clrUnits = this.chariotUnits(this.state.deviceConfig?.FlowAUnits);
                if (clrUnits == "litres") {
                    clrUnits = "l/s";
                }
                else {
                    clrUnits = "m3/h";
                }
            }
            if (inputValue == "2" && this.state.deviceConfig?.FlowAUnits) {
                clrUnits = this.chariotUnits(this.state.deviceConfig?.FlowAUnits);
            }
            if ((inputValue == "3" || inputValue == "11") && this.state.deviceConfig?.AnalogueCUnits) {
                clrUnits = this.chariotUnits(this.state.deviceConfig?.AnalogueCUnits);
            }
            if ((inputValue == "7" || inputValue == "12") && this.state.deviceConfig?.AnalogueDUnits) {
                clrUnits = this.chariotUnits(this.state.deviceConfig?.AnalogueDUnits);
            }
            if (inputValue == "30") {
                clrUnits = "N/A";
            }
            if (inputValue == "31") {
                clrUnits = "mV";
            }
        }

        this.setState({ editAlarm: alarm, setUnits: setUnits, clrUnits:  setUnits, tempAlarmUnits: setUnits });

    }

    handleCreateAlarms = ():void => {
       
        for (let i = 0; i < this.state.alarms.length; i++) {
            if (!this.state.alarms[i].AlarmMessage) {
                this.handleAlarmRowDblClick(i + 1)

                return
            }
        }

        
    }

    handleAlarmRowDblClick = (index: any): void => {

        const interval = this.state.deviceConfig?.TransmissionInterval ? this.state.deviceConfig?.TransmissionInterval : 0;
        const alarm = Object.assign({}, this.state.alarms[index -1]);
        let setUnits = "";
        let clrUnits = "";
        let tempAlarmUnits = "";

        // Set units based on set/clrInput
        if (alarm.SetInput == 1 && this.state.deviceConfig?.FlowAUnits) {
            setUnits = this.chariotUnits(this.state.deviceConfig?.FlowAUnits);
            
        }
        if (alarm.SetInput == 2 && this.state.deviceConfig?.FlowAUnits) {
            setUnits = this.chariotUnits(this.state.deviceConfig?.FlowAUnits);
        }
        if ((alarm.SetInput == 3 || alarm.SetInput == 11) && this.state.deviceConfig?.AnalogueCUnits) {
            setUnits = this.chariotUnits(this.state.deviceConfig?.AnalogueCUnits);
        }
        if ((alarm.SetInput == 7 || alarm.SetInput == 12) && this.state.deviceConfig?.AnalogueDUnits) {
            setUnits = this.chariotUnits(this.state.deviceConfig?.AnalogueDUnits);
        }
        if (alarm.SetInput == 30) {
            setUnits = "";
        }
        if (alarm.SetInput == 31) {
            setUnits = "mV";
        }
        tempAlarmUnits = setUnits

        if (alarm.ClrInput == 1 && this.state.deviceConfig?.FlowAUnits) {
            clrUnits = this.chariotUnits(this.state.deviceConfig?.FlowAUnits);
        }
        if (alarm.ClrInput == 2 && this.state.deviceConfig?.FlowAUnits) {
            clrUnits = this.chariotUnits(this.state.deviceConfig?.FlowAUnits);
        }
        if ((alarm.ClrInput == 3 || alarm.ClrInput == 11) && this.state.deviceConfig?.AnalogueCUnits) {
            clrUnits = this.chariotUnits(this.state.deviceConfig?.AnalogueCUnits);
        }
        if ((alarm.ClrInput == 7 || alarm.ClrInput == 12) && this.state.deviceConfig?.AnalogueDUnits) {
            clrUnits = this.chariotUnits(this.state.deviceConfig?.AnalogueDUnits);
        }
        if (alarm.ClrInput == 30) {
            clrUnits = "N/A";
        }
        if (alarm.ClrInput == 31) {
            clrUnits = "mV";
        }
        
        alarm.SetCountStr = this.loadTimeframe(alarm.SetCount, interval)
        alarm.ClrCountStr = this.loadTimeframe(alarm.ClrCount, interval)
        this.setState({ editAlarm: alarm, alarmTab: 1, setUnits: setUnits, clrUnits: setUnits, tempAlarmUnits: tempAlarmUnits });

    }
    handleAlarmTabChange = (e: any, v: any): void => {

        this.setState({ alarmTab: v });

    }

    
    countModifier = (count: string, transInterval: number): number => {
        if (transInterval === 5) {
            if (count === '5mins') {
                return 1
            } else if (count === '10mins') {
                return 2
            } else if (count === '15mins') {
                return 3
            } else if (count === '30mins') {
                return 6
            } else if (count === '1hour') {
                return 12
            } else if (count === '3hour') {
                return 36
            } else if (count === '6hour') {
                return 72
            } else if (count === '12hour') {
                return 144
            } else if (count === '24hour') {
                return 288
            }
        } else if (transInterval === 15) {
            if (count === '15mins') {
                return 1
            } else if (count === '30mins') {
                return 2
            } else if (count === '1hour') {
                return 4
            } else if (count === '3hour') {
                return 12
            } else if (count === '6hour') {
                return 24
            } else if (count === '12hour') {
                return 48
            } else if (count === '24hour') {
                return 96
            }
        } else if (transInterval === 30) {
            if (count === '30mins') {
                return 1
            } else if (count === '1hour') {
                return 2
            } else if (count === '3hour') {
                return 6
            } else if (count === '6hour') {
                return 12
            } else if (count === '12hour') {
                return 24
            } else if (count === '24hour') {
                return 48
            }
        } else if (transInterval === 60) {
            if (count === '1hour') {
                return 1
            } else if (count === '3hour') {
                return 3
            } else if (count === '6hour') {
                return 6
            } else if (count === '12hour') {
                return 12
            } else if (count === '24hour') {
                return 24
            }
        } else if (transInterval === 180) {
            if (count === '3hour') {
                return 1
            } else if (count === '6hour') {
                return 2
            } else if (count === '12hour') {
                return 4
            } else if (count === '24hour') {
                return 8
            }
        } else if (transInterval === 360) {
            if (count === '6hour') {
                return 1
            } else if (count === '12hour') {
                return 2
            } else if (count === '24hour') {
                return 4
            }
        } else if (transInterval === 720) {
            if (count === '12hour') {
                return 1
            } else if (count === '24hour') {
                return 2
            }
        } else if (transInterval === 1440) {
            if (count === '24hour') {
                return 1
            }
        }     
        return 0;
    }

    convertThreshold = (data, type): number => {
        const pressure = [3, 7, 11, 22] // taken for pressure SetImput from enumchariot input
        const pressureUnitsDevice = {
            "03": "Bar",
            "04": "mb",
            "05": "mH2O",
            "06": "psi"
        }
        //if (type === 'set') {
        //    const threshold = data.data.SetThreshold
        //    if (threshold === 0) {
        //        return 0
        //    } else {
        //        if (pressure.includes(data.data.SetInput)) {
        //            return pressureConverter()
        //        }
                
        //    }
        //}
        return 1
    }
    thresholdConverter = (userUnit): number => {
        let conversion = 1
        const deviceUnit = this.state.setUnits
        if (deviceUnit === 'mH2O') {
            switch (userUnit) {
                case "mH2O":
                    conversion = 98.0665
                    break
                case "psi":
                    conversion = 0.4335
                    break
                case "bar":
                    conversion = 0.0980665
                    break
                case "millibar":
                    conversion = 1
                    break
            }
        } else if (deviceUnit === 'psi') {
            switch (userUnit) {
                case "mH2O":
                    conversion = 0.70307
                    break
                case "psi":
                    conversion = 1
                    break
                case "bar":
                    conversion = 0.0689476
                    break
                case "millibar":
                    conversion = 68.9476
                    break
            }
        } else if (deviceUnit === 'bar') {
            switch (userUnit) {
                case "mH2O":
                    conversion = 10.1972
                    break
                case "psi":
                    conversion = 14.5038
                    break
                case "bar":
                    conversion = 1
                    break
                case "millibar":
                    conversion = 1/ 1000
                    break
            }
        } else if (deviceUnit === 'millibar') {
            switch (userUnit) {
                case "mH2O":
                    conversion = 0.0101972
                    break
                case "psi":
                    conversion = 0.0145038
                    break
                case "bar":
                    conversion = 1000
                    break
                case "millibar":
                    conversion = 1
                    break
            }
        } else if (deviceUnit === 'l') {
            switch (userUnit) {
                case "l":
                    conversion = 1
                    break
                case "m3":
                    conversion = 1 / 1000
                    break
                case "gal":
                    conversion = 0.264172
                    break
                case "ft/3":
                    conversion = 0.0353147
                    break
            }
        } else if (deviceUnit === 'm3') {
            switch (userUnit) {
                case "l":
                    conversion = 1000
                    break
                case "m3":
                    conversion = 1
                    break
                case "gal":
                    conversion = 264.172
                    break
                case "ft/3":
                    conversion = 35.3147
                    break
            }
        } else if (deviceUnit === 'l/s') {
            if (userUnit === 'l/s') {
                conversion = 1
            } else if (userUnit === 'm3/h') {
                conversion = 3.6
            } else if (userUnit === "gpm") {
                conversion = 15.8503
            } else if (userUnit === 'MGD') {
                conversion = 0.022824
            } else if (userUnit === 'gps') {
                conversion = 0.264172
            } else if (userUnit === 'cfs') {
                conversion = 0.0353147
            }
        } else {
            return 1
        }


        return conversion
    }


    updateAlarm = (): void => {

        // Call API to update AlarmConfig

        const alarm = this.state.editAlarm;
        const interval = this.state.deviceConfig?.TransmissionInterval ? this.state.deviceConfig?.TransmissionInterval : 0;
        if (alarm) {
            alarm.SetThreshold = parseFloat(alarm?.SetThresholdStr);
            alarm.ClrThreshold = parseFloat(alarm?.ClrThresholdStr);
            alarm.MaxAlarms = parseInt(alarm?.MaxAlarmsStr);
            alarm.SetCount = this.countModifier(alarm?.SetCountStr, interval);
            alarm.ClrCount = this.countModifier(alarm?.ClrCountStr, interval);
            alarm.SetThreshold = alarm.SetThreshold * this.thresholdConverter(this.state.editAlarm?.Unit)
            alarm.ClrThreshold = alarm.ClrThreshold * this.thresholdConverter(this.state.editAlarm?.Unit)
            
            // Check for any missing fields
            if (alarm.AlarmClass == 0) {
                alert(this.props.intl.formatMessage({ id: "You must set a severity" }));
                return;
            }
            if (alarm.AlarmMessage.length == 0) {
                alert(this.props.intl.formatMessage({ id: "Please define an alarm message" }))
                return;
            }
        }


        const me = this;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(alarm)
        };
        
        CallGetAPI(CreateUrl(`/api/aquaguard/ContactsForCompany?companyId=${sessionStorage.getItem('companyId')}`), {})
            .then(data => {
                if (data.length === 0) {
                    alert(this.props.intl.formatMessage({ id: 'You have no contacts in your contact details in your contact list to receive these alarms, please add some' }))
                }
                CallGetAPI(CreateUrl('/api/Aquaguard/LCAlarmConfiguration'), requestOptions)
                    .then(data => {
                        if (data.status === undefined) {
                            const alarm = me.state.editAlarm;
                            if (alarm) {
                                alarm.Id = data.id;
                            }

                            // Save current editAlarm details in config
                            const alarms = me.state.alarms;
                            if (alarms && alarm) {
                                alarms[alarm.Idx - 1] = alarm;
                                me.setState({ alarms: alarms });
                            }
                            me.setState({ editAlarm: undefined, alarmTab: 0 });

                            me.createSuccessNotification(this.props.intl.formatMessage({ id: "Alarm Config saved" }));
                        }
                        else {
                            me.createErrorNotification(this.props.intl.formatMessage({ id: 'Error Saving Alarm Config Changes' }));
                        }
                    })
                    .catch(function (error) {
                        me.createErrorNotification(this.props.intl.formatMessage({ id: 'Error Saving Alarm Config Changes' }));
                        console.log(error);
                    });
            })
            .catch(err => {
                me.createErrorNotification(this.props.intl.formatMessage({ id: 'There was an error checking your contacts list' }))
                console.log(err)
            })

    }

    deleteAlarm(id: number | undefined): void {
        if (window.confirm(this.props.intl.formatMessage({ id: "Are you sure you want to delete the alarm?" }))) {
            CallDeleteAPI(CreateUrl(`/api/aquaguard/LCLAlarmConfig/${id}`), {})
                .then(async data => {
                    await this.loadAlarmConfigs()
                    this.setState({ alarmTab: 0 })
                })
                .catch(function (error) {

                    console.log(error);
                });
        }
    }

    // Display render functions
    inputColumnCustomizeText(cellInfo: any, intl: any): string {
        switch (cellInfo.valueText) {
            case '1':
                return intl.formatMessage({ id: "Flow A" });
            case '9':
                return intl.formatMessage({ id: "Flow B" });
            case '3':
                return intl.formatMessage({ id: "Latest Pressure C" });
            case '7':
                return intl.formatMessage({ id: "Latest Pressure D" });
            case '11':
                return intl.formatMessage({ id: "Pressure C Difference" });
            case '12':
                return intl.formatMessage({ id: "Pressure D Difference" });
            case '21':
                return intl.formatMessage({ id: "Consumption A" });
            case '22':
                return intl.formatMessage({ id: "Consumption B" });
            case '30':
                return intl.formatMessage({ id: "Signal Strength (0-31)" });
            case '31':
                return intl.formatMessage({ id: "Battery (mV)" });
            default:
                return "";
        }


    }

    classColumnCustomizeText(cellInfo: any, intl: any): string {
        switch (cellInfo.valueText) {
            case '7':
                return intl.formatMessage({ id: "Low" });
            case '6':
                return intl.formatMessage({ id: "Normal" });
            case '5':
                return intl.formatMessage({ id: "High" });
            case '4':
                return intl.formatMessage({ id: "Critical" });
            default:
                return intl.formatMessage({ id: "Not set" });
        }
    }

    configUpdateChanged = (event: any): void => {
        const config = this.state.deviceConfig;
        if (config) {
            config.Custom = event.target.value;
            this.setState({ deviceConfig: config, enableSend: true, });
        }
    }

    is2FlowChariot = (swVersion: string | undefined): boolean => {
        if (swVersion)
            return swVersion >= "2.4.1";   // Firmware version >= 2.5, i.e. has second flow
        else
            return false;
    }

    // Renders the appropriate SELECT items based on the logging interval (in secs)
    generateSamplingIntervals = (logInterval: number | undefined): Array<{ value: string, label: string }> => {
        if (logInterval) {
            switch (logInterval) {
                case 30:
                    return [{ value: "15", label: "15s" }]
                case 60:        // 1 min
                    return [
                        { value: "15", label: "15s" },
                        { value: "20", label: "20s" },
                        { value: "30", label: "30s" },
                    ]
                case 300:       // 5 min
                    return [
                        { value: "15", label: "15s" },
                        { value: "20", label: "20s" },
                        { value: "30", label: "30s" },
                        { value: "60", label: "1m" },
                    ]
                case 600:     // 10 min
                    return [
                        { value: "15", label: "15s" },
                        { value: "20", label: "20s" },
                        { value: "30", label: "30s" },
                        { value: "60", label: "1m" },
                        { value: "120", label: "2m" },
                    ]
                case 900:     // 15 min
                    return [
                        { value: "15", label: "15s" },
                        { value: "20", label: "20s" },
                        { value: "30", label: "30s" },
                        { value: "45", label: "45s" },
                        { value: "60", label: "1m"},
                        { value: "180", label: "3m" },
                    ]
                case 1800:     // 30 min
                    return [
                        { value: "30", label: "30s" },
                        { value: "45", label: "45s" },
                        { value: "60", label: "1m" },
                        { value: "120", label: "2m" },
                        { value: "180", label: "3m" },
                        { value: "300", label: "5m" },
                        { value: "600", label: "10m" },
                        { value: "900", label: "15m" },
                    ]

                case 3600:     // 60 min
                    return [
                        { value: "60", label: "1m" },
                        { value: "120", label: "2m" },
                        { value: "180", label: "3m" },
                        { value: "240", label: "4m" },
                        { value: "300", label: "5m" },
                        { value: "600", label: "10m" },
                        { value: "900", label: "15m" },
                    ]

                default:
                    return []
            }
        }

        return []
    }

    handleInactiveClick = (): void => {
        let dormant = false
        const config = {...this.state.deviceConfig}
        if (!this.state.dormant) {
            dormant = window.confirm(this.props.intl.formatMessage({ id: 'Are you sure you want to turn this device off. You will not be able to turn it back on remotely. All un-transmitted data will resend once the device is turned back on via the app and will still be assign to the current site (if assigned)' }))
        }
        if (dormant) {
            config.Dormant = true
            this.setState({ dormant: true, allowConfig: false, deviceConfig: config, enableSend: true })
        } else {
            this.setState({ dormant: false })
        }
    }

    handleConfirmTextChange = (e, type): void => {
        

        if (type === 'inactive' && e.target.value === 'INACTIVE') {
            this.setState({ allowConfig: true })
        }
        if (type === 'battery' && e.target.value === 'BATTERY') {
            this.setState({ allowConfig: true })
        }
        this.setState({ confirmText: e.target.value })
    }


    handelTempAlarmUnitChange(e): void {
        const editAlarm = this.state.editAlarm

        editAlarm.Unit = e.target.value
        this.setState({ editAlarm: editAlarm })
        
    }

    handleBatteryResetClick(): void {
        const config = { ...this.state.deviceConfig }
        config.BatteryReset = !this.state.batteryReset
        this.setState({ batteryReset: !this.state.batteryReset, deviceConfig: config, enableSend: true, allowConfig: false  })

    }

    handleConfigMessageRequestClick(): void {
        const config = { ...this.state.deviceConfig }
        config.ConfigMessageRequest = !this.state.configMessageRequest
        this.setState({ configMessageRequest: !this.state.configMessageRequest, deviceConfig: config, enableSend: true, allowConfig: true })
    }

    handleStatusMessageRequestClick(): void {
        const config = { ...this.state.deviceConfig }
        config.StatusMessageRequest = !this.state.statusMessageRequest
        this.setState({ statusMessageRequest: !this.state.statusMessageRequest, deviceConfig: config, enableSend: true, allowConfig: true })
    }

    handleSigCheckRequestClick(): void {
        const config = { ...this.state.deviceConfig }
        config.SigCheckRequest = !this.state.sigCheckRequest
        this.setState({ sigCheckRequest: !this.state.sigCheckRequest, deviceConfig: config, enableSend: true, allowConfig: true })
    }

    
    decodeMultiplier(stepValue: number): number {
        if (stepValue <= 1) {
            return 0.0001;
        }
        if (stepValue === 2) {
            return 0.001;
        }
        if (stepValue === 3) {
            return 0.01;
        }
        if (stepValue === 4) {
            return 0.1;
        }
        if (stepValue === 5) {
            return 1; 
        }
        const numberOfFactorsOfTen = stepValue - 5;
        return Math.pow(10, numberOfFactorsOfTen);
    }

    buildUnitCategories(units: Record<string, { category: string; value: string }>): React.ReactNode {
        const categoryMap: Record<string, React.ReactNode[]> = {};

        Object.keys(units).forEach((unitKey) => {
            const unit = inputUnits[unitKey];
            if (!categoryMap[unit.category]) {
                categoryMap[unit.category] = [];
            }
            categoryMap[unit.category].push(
                <option key={unitKey} value={unitKey}>
                    {unit.name}
                </option>
            );
        });

        const returnArr = Object.entries(categoryMap).map(([categoryLabel, categoryOptions]) => (
            <optgroup key={categoryLabel} label={categoryLabel}>
                {categoryOptions}
            </optgroup>
        ));
        console.log(returnArr)
        return returnArr
    }

    render(): ReactNode {

        const FW = parseFloat(this.state.deviceConfig?.SWversion.split(".")?.[0] + "." + this.state.deviceConfig?.SWversion.split(".")?.[1])

        const classes = makeStyles(style);

        const blockUpdate = this.state.deviceConfig?.SWversion.length == 5 && (this.state.deviceConfig?.SWversion.startsWith("1.1.0") || this.state.deviceConfig?.SWversion.startsWith("1.1.1"));
        const {intl} = this.props
        return (
            <div>
                <div style={{marginTop: "10px"} }>
                    <Button
                        id="read-button"
                        onClick={this.handleReadClick}
                        color="secondary"
                        variant="contained"
                        style={{ margin: "0 10px 0 17px" }}
                        startIcon={<RefreshRoundedIcon />}
                    >
                        {intl.formatMessage({ id: 'Reload Config' })}
                    </Button>
                    <Button
                        id="send-button"
                        onClick={this.handleSendClick}
                        disabled={!this.state.enableSend || blockUpdate}
                        color="primary"
                        variant="contained"
                    >
                        {intl.formatMessage({ id: 'Send To Logger' })}
                    </Button>

                    {this.state.deviceConfig &&
                        <div style={{ float: "right", paddingRight: "30px", paddingTop: "5px" }}>
                            <p>{`${intl.formatMessage({ id: 'Configuration as of' })} ${moment(this.state.configDate).format("DD/MM/yyyy HH:mm")} ${intl.formatMessage({ id: "updated by" })} ${this.state.lastConfigUser ? this.state.lastConfigUser : 'Super Admin'} ${intl.formatMessage({ id: 'via' })} ${this.state.typeOfUpdate}`}</p>
                        {this.state.deviceConfig.UpdateJSON &&
                                <div>{intl.formatMessage({ id: 'including pending updates' })}</div>
                        }
                        </div>
                    }
                </div>
                {this.state.panel == "Config" &&
                    <CustomTabs
                        headerColor="info"
                        tabs={[
                            {
                                tabName: intl.formatMessage({ id: "Device Details" }),
                                tabContent: (
                                    <div>
                                        <div>{intl.formatMessage({ id: 'Unit Details' })}</div>
                                        <Box border={2} padding={3}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={2}>
                                                    {intl.formatMessage({ id: 'Serial Number' })}:
                                                </Grid>
                                                <Grid item xs={2}>
                                                    {this.props.serial}
                                                </Grid>
                                                <Grid item xs={4}>
                                                    {intl.formatMessage({ id: 'Computer Time (UTC) (Last connection)' })}
                                                </Grid>
                                                <Grid item xs={4}>
                                                    {
                                                        this.state.deviceConfig?.LastConnection != null &&
                                                        moment(this.state.deviceConfig?.LastConnection).format("DD/MM/YYYY HH:mm:ss")
                                                    }
                                                </Grid>

                                                <Grid item xs={2}>
                                                    {intl.formatMessage({ id: 'Product' })}:
                                                </Grid>
                                                <Grid item xs={2}>
                                                    {this.props.product}
                                                </Grid>
                                                <Grid item xs={4}>
                                                    {intl.formatMessage({ id: 'Unit Time (UTC)' })}
                                                </Grid>
                                                <Grid item xs={4}>
                                                    {
                                                        this.state.deviceConfig?.LoggerTime != null &&
                                                        moment(this.state.deviceConfig?.LoggerTime).format("DD/MM/YYYY HH:mm:ss")
                                                    }
                                                </Grid>

                                                {!window.location.hostname.includes('zonelog.net') && <Grid item xs={2}>
                                                    {intl.formatMessage({ id: 'Model' })}:
                                                </Grid>}
                                                {!window.location.hostname.includes('zonelog.net') && <Grid item xs={2}>
                                                    {this.props.model}
                                                </Grid>}
                                                <Grid item xs={4}>
                                                    {intl.formatMessage({ id: 'SW Version' })}
                                                </Grid>
                                                <Grid item xs={4}>
                                                    {this.state.deviceConfig?.SWversion}
                                                </Grid>
                                                <Grid item xs={2}>
                                                    {blockUpdate &&
                                                        <p color='red'>{intl.formatMessage({ id: 'Cannot remotely update this version' })}</p>
                                                    }
                                                </Grid>
                                                <Grid item xs={2}>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                        <div>{intl.formatMessage({ id: 'Unit State' })}</div>
                                        <Box border={2} padding={3}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={3}>
                                                    {intl.formatMessage({ id: 'Current state' })}
                                                </Grid>
                                                <Grid item xs={3}>
                                                    {this.state.deviceConfig?.CurrentState}
                                                </Grid>
                                                <Grid item xs={6}>
                                                    {/*this.state.deviceConfig?.CurrentState == "Commissioned" &&
                                                         <div>Use &quot;Undeploy&quot; to decommission the device.</div>
                                                    */}
                                                </Grid>
                                                <Grid item xs={1}>
                                                    {intl.formatMessage({ id: 'GUID' })}:
                                                </Grid>
                                                <Grid item xs={5}>
                                                    {this.state.deviceConfig?.Guid}
                                                </Grid>
                                                <Grid item xs={6}>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                        <div>{intl.formatMessage({ id: 'Device Details' })}</div>
                                        <Box border={2} padding={3}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={3}>
                                                    {intl.formatMessage({ id: 'Device Name' })}:
                                                </Grid>
                                                <Grid item xs={9}>
                                                    <TextField
                                                        fullWidth={true}
                                                        variant="outlined"
                                                        size="small"
                                                        name="Sitename"
                                                        value={this.state.deviceConfig?.Sitename}
                                                        onChange={this.handleTextfieldChange.bind(this)}
                                                        
                                                    />
                                                    {this.state.deviceConfig?.Sitename.length === 25 && <p>{intl.formatMessage({ id: 'Device Name can be no longer than 25 characters' })}</p> }
                                                </Grid>
                                            </Grid>
                                        </Box>
                                       
                                        {this.state.deviceConfig?.Latitude && this.state.deviceConfig?.Longitude && <Box border={2} padding={3} ><GoogleMapsGPSSet gps={{ lat: this.state.deviceConfig?.Latitude, lng: this.state.deviceConfig?.Longitude }} serial={this.props.serial} setLoggerLocation={this.setLoggerLocation} /></Box>}
                                        {/*<Box border={2} padding={3}>*/}
                                        {/*    {this.state.ready &&*/}
                                        {/*        (this.state.deviceConfig?.Longitude && this.state.deviceConfig?.Latitude) ? <WebMapView center={[this.state.deviceConfig?.Longitude, this.state.deviceConfig?.Latitude]}*/}
                                        {/*            height="30vh"*/}
                                        {/*            zoom={15}*/}
                                        {/*            colour={"primary"}*/}
                                        {/*            trunkSegments={[]}*/}
                                        {/*            regions={[]}*/}
                                        {/*            sites={[]}*/}
                                        {/*            showRegions={false}*/}
                                        {/*            showAllSites={false}*/}
                                        {/*            showRainfall={false}*/}
                                        {/*            alarmFilter={-1}*/}
                                        {/*            singlePoints={[*/}
                                        {/*                {*/}
                                        {/*                    id: this.props.serial,*/}
                                        {/*                    name: this.props.serial,*/}
                                        {/*                    colour: this.state.loggerHold ? "red" : "black",*/}
                                        {/*                    coordinates: [this.state.deviceConfig?.Longitude || 0, this.state.deviceConfig?.Latitude || 0],*/}
                                        {/*                }*/}
                                        {/*            ]}*/}
                                        {/*            singlePointsDesc="Logger"*/}
                                        {/*            onHold={this.handleLoggerHold}*/}
                                        {/*            onRelease={this.setLoggerLocation}*/}
                                        {/*            mouseWheelZoom={false}*/}
                                        {/*    /> :*/}
                                        {/*        <div style={{display: "flex", justifyContent: "center"} }>*/}
                                        {/*            <p>{intl.formatMessage({ id: 'No GPS set for this device' })}</p>*/}
                                        {/*        </div>*/}
                                        {/*    }*/}
                                        {/*</Box>*/}

                                    </div>
                                )
                            },
                            {
                                tabName: intl.formatMessage({ id: "Communication" }),
                                disabled: !this.state.ready,
                                tabContent: (
                                    <div>
                                        <div>{intl.formatMessage({ id: 'General Settings' })}</div>
                                        <Box border={2} padding={3}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={2}>
                                                    {intl.formatMessage({ id: "Preferred LPWAN" })}
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Select
                                                        name="PreferredLPWAN"
                                                        size="small"
                                                        style={{ margin: 0, paddingBottom: 0 }}
                                                        value={this.state.deviceConfig?.PreferredLPWAN}
                                                        onChange={this.handleSelectChange.bind(this)}
                                                    >
                                                        <MenuItem value="07" style={{width: "100px"} }>
                                                            <div style={{display: "flex"} }>
                                                                <ListItemIcon>
                                                                    <img src={lte} style={{width: "12%"} } />
                                                                </ListItemIcon>
                                                                
                                                            </div>
                                                        </MenuItem>

                                                        <MenuItem value="09" style={{ width: "100px" }}>
                                                            <ListItemIcon>
                                                                <img src={nbiot} style={{ width: "12%" }} />
                                                            </ListItemIcon>
                                                            
                                                        </MenuItem>
                                                    </Select>
                                                </Grid>
                                                <Grid item xs={2}>
                                                </Grid>
                                                <Grid item xs={4}>
                                                </Grid>
                                                <Grid item xs={12}>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    {intl.formatMessage({ id: "Server" })}
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <TextField name="MQTTServer" fullWidth={false} variant="outlined" size="small" value={this.state.deviceConfig?.MQTTServer} onChange={this.handleTextfieldChange.bind(this)} />
                                                </Grid>
                                                <Grid item xs={2}>
                                                    {intl.formatMessage({ id: 'APN Settings' })}
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <TextField name="APN Settings" fullWidth={false} variant="outlined" size="small" value={this.state.deviceConfig?.APN}  />
                                                </Grid>
                                                <Grid item xs={2}>
                                                </Grid>
                                                <Grid item xs={4}>
                                                </Grid>
                                                {FW >= 2.99 ?
                                                    <><Grid item xs={12}>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        Reduced Mobility
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                      <Switch name="ReducedMobility" size="small" color="secondary" checked={this.state.deviceConfig?.ReducedMobility} onChange={this.handleToggleChange.bind(this)} /> {intl.formatMessage({ id: 'Enable' })}                                                               
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        Frequency Band Selector
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Switch name="FreqBandB3" size="small" color="secondary" checked={this.state.deviceConfig?.FreqBandB3} onChange={this.handleToggleChange.bind(this)} /> B3                           
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Switch name="FreqBandB20" size="small" color="secondary" checked={this.state.deviceConfig?.FreqBandB20} onChange={this.handleToggleChange.bind(this)} /> B20
                                                    </Grid></>
                                                :
                                                    null
                                                }
                                                
                                            </Grid>
                                        </Box>
                                        <div>{intl.formatMessage({ id: 'Data Transmission Schedule' })}</div>
                                        <Box border={2} padding={3}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={4}>
                                                    <Switch size="small" color="secondary" checked={this.state.deviceConfig?.TransmissionInterval != undefined && this.state.deviceConfig?.TransmissionInterval?.valueOf() > 0} disabled={true} /> Enable
                                                </Grid>
                                                
                                                <Grid item xs={1}>
                                                    {intl.formatMessage({ id: 'Transmission Interval' })}
                                                </Grid>
                                                <Grid item xs={3}>

                                                    <Select
                                                        name="TransmissionInterval"
                                                        size="small"
                                                        style={{ margin: 0, paddingBottom: 0 }}
                                                        value={this.state.deviceConfig?.TransmissionInterval}
                                                        onChange={this.handleSelectChange.bind(this)}
                                                    >
                                                        {/*<MenuItem value="0">Never</MenuItem>*/}
                                                        {this.state.minInterval >= 1800 && <MenuItem value="1440">24 {intl.formatMessage({ id: 'Hour' })}</MenuItem>}
                                                        {this.state.minInterval >= 900 && <MenuItem value="720">12 {intl.formatMessage({ id: 'Hour' })}</MenuItem>}
                                                        {this.state.minInterval >= 600 && <MenuItem value="360">6 {intl.formatMessage({ id: 'Hour' })}</MenuItem>}
                                                        {this.state.minInterval >= 300 && <MenuItem value="180">3 {intl.formatMessage({ id: 'Hour' })}</MenuItem>}
                                                        {this.state.minInterval >= 60 && <MenuItem value="60">1 {intl.formatMessage({ id: 'Hour' })}</MenuItem>}
                                                        {this.state.minInterval >= 30 && <MenuItem value="30">30 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>}
                                                        {this.state.minInterval >= 15 && <MenuItem value="15">15 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>}
                                                        {this.state.minInterval >= 10 && <MenuItem value="10">10 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>}
                                                        <MenuItem value="5">5 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                    </Select>
                                                </Grid>
                                                {/*<Grid item xs={4}>*/}
                                                {/*    <Button variant="contained" onClick={(): void => this.handleInactiveClick()} color={this.state.dormant ? "primary" : "warning"}>{this.state.dormant ? 'Undo Inactive' : 'Make device inactive'}</Button>*/}
                                                {/*</Grid>*/}
                                            </Grid>
                                        </Box>
                                    </div>
                                )
                            },
                            ((this.state.meterConfig & 0x01) != 0 ?
                                {
                                    tabName: this.state.deviceConfig?.SWversion && semver.gte(this.state.deviceConfig?.SWversion, '2.5.1') ? intl.formatMessage({ id: "Flow / Pulse / Digital Channel A" }) : intl.formatMessage({ id: "Flow Channel A" }),
                                    disabled: !this.state.ready,

                                    tabContent: (
                                        <div>

                                            <div>
                                                {// Channel A
                                                    (this.state.meterConfig & 0x01) != 0 &&
                                                    <div>
                                                            <div>{this.state.deviceConfig?.SWversion && semver.gte(this.state.deviceConfig?.SWversion, '2.5.1') ? intl.formatMessage({ id: "Flow / Digital Channel A" }) : intl.formatMessage({ id: "Flow Channel A" })}</div>
                                                        <Box border={2} padding={3}>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12}>
                                                                        <Switch name="FlowA" size="small" color="secondary" checked={this.state.deviceConfig?.FlowA} onChange={this.handleToggleChange.bind(this)} /> {intl.formatMessage({ id: 'Enable' })}
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                        {intl.formatMessage({ id: 'Channel Reference' })}
                                                                </Grid>
                                                                <Grid item xs={8}>
                                                                    <TextField name="FlowARef" fullWidth={false} variant="outlined" size="small" value={this.state.deviceConfig?.FlowARef} onChange={this.handleTextfieldChange.bind(this)} disabled={!this.state.deviceConfig?.FlowA} />
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                        {intl.formatMessage({ id: 'Input Type' })}:
                                                                </Grid>
                                                                    <Grid item xs={8}>
                                                                    <Select
                                                                        name="FlowAPulseType"
                                                                        style={{ margin: 0, paddingBottom: 0 }}
                                                                        value={this.state.deviceConfig?.FlowAPulseType}
                                                                        disabled={!this.state.deviceConfig?.FlowA}
                                                                        onChange={this.handleFlowTypeChange.bind(this)}
                                                                    >
                                                                        <MenuItem value={1}>{intl.formatMessage({ id: 'Forward' })}</MenuItem>
                                                                        <MenuItem value={2}>{intl.formatMessage({ id: 'Fwd/Rev' })}</MenuItem>
                                                                        <MenuItem value={3}>{intl.formatMessage({ id: 'Fwd/Dir' })}</MenuItem>
                                                                        {this.state.deviceConfig?.SWversion && semver.gte(this.state.deviceConfig?.SWversion, '2.5.1') && <MenuItem value={17}>{intl.formatMessage({ id: 'Forward (PIT)' })}</MenuItem>}
                                                                        {this.state.deviceConfig?.SWversion && semver.gte(this.state.deviceConfig?.SWversion, '2.5.1') && <MenuItem value={18}>{intl.formatMessage({ id: 'Fwd/Rev (PIT)' })}</MenuItem>}
                                                                        {this.state.deviceConfig?.SWversion && semver.gte(this.state.deviceConfig?.SWversion, '2.5.1') && <MenuItem value={20}>{intl.formatMessage({ id: 'Digital' })}</MenuItem>}
                                                                    </Select>

                                                                    </Grid>
                                                                    {this.state.deviceConfig?.FlowAPulseType != 20 &&
                                                                        <Grid item xs={4}>
                                                                            {intl.formatMessage({ id: 'Pulse Multiplier' })}
                                                                        </Grid>}
                                                                    {this.state.deviceConfig?.FlowAPulseType != 20 && <Grid item xs={8}>
                                                                        <TextField name="FlowAMultiplier"
                                                                            fullWidth={false}
                                                                            variant="outlined"
                                                                            size="small"
                                                                            value={this.state.deviceConfig?.FlowAMultiplierStr}
                                                                            onChange={this.handleTextfieldChange.bind(this)}
                                                                            disabled={!this.state.deviceConfig?.FlowA}
                                                                            error={this.state.fieldErrors.FlowAMultiplier}
                                                                            helperText={this.state.fieldErrors.FlowAMultiplier ? intl.formatMessage({ id: "Must be DECIMAL number" }) : ""}
                                                                        />
                                                                        {console.log(this.state.deviceConfig?.FlowAUnits, this.state.deviceConfig?.FlowBUnits) }
                                                                        <Select
                                                                            name="FlowAUnits"
                                                                            style={{ margin: 0, paddingBottom: 0 }}
                                                                            size="small"
                                                                            value={this.state.deviceConfig?.FlowAUnits}
                                                                            disabled={!this.state.deviceConfig?.FlowA}
                                                                            onChange={this.handleSelectChange.bind(this)}
                                                                        >
                                                                            <MenuItem value="01">{intl.formatMessage({ id: 'Litres' })}</MenuItem>
                                                                            <MenuItem value="02">{intl.formatMessage({ id: 'M3' })}</MenuItem>
                                                                            <MenuItem value="07">{intl.formatMessage({ id: 'US Gallons' })}</MenuItem>
                                                                            <MenuItem value="08">{intl.formatMessage({ id: 'ft3' })}</MenuItem>
                                                                            <MenuItem value="15">mm</MenuItem>
                                                                            <MenuItem value="16">cm</MenuItem>
                                                                        </Select>
                                                                        
                                                                        {((this.state.orgConfig?.FlowAMultiplierStr !== this.state.deviceConfig?.FlowAMultiplierStr) ||
                                                                            (this.state.orgConfig?.FlowAUnits !== this.state.deviceConfig?.FlowAUnits)) &&
                                                                            <p>{intl.formatMessage({ id: 'Warning! Change the multiplier whilst logging data will dramatically change the graphing function and may be difficult to read for a while'})}</p>
                                                                        }
                                                                    </Grid>}
                                                                    
                                                                    <Grid item xs={12}>
                                                                    </Grid>
                                                                    {(this.state.deviceConfig?.FlowAPulseType === 1
                                                                        || this.state.deviceConfig?.FlowAPulseType === 2
                                                                        || this.state.deviceConfig?.FlowAPulseType === 3

                                                                    ) &&
                                                                        <Grid item xs={4}>
                                                                            {intl.formatMessage({ id: 'Logging Interval' })}
                                                                        </Grid>}
                                                                    {(this.state.deviceConfig?.FlowAPulseType === 1
                                                                        || this.state.deviceConfig?.FlowAPulseType === 2
                                                                        || this.state.deviceConfig?.FlowAPulseType === 3
                                                                    ) && <Grid item xs={8}>
                                                                            <Select
                                                                                name="FlowASchedule"
                                                                                size="small"
                                                                                style={{ margin: 0, paddingBottom: 0 }}
                                                                                value={this.state.deviceConfig?.FlowASchedule}
                                                                                disabled={!this.state.deviceConfig?.FlowA}
                                                                                onChange={this.handleSelectChange.bind(this)}
                                                                            >
                                                                                <MenuItem value="43200">12 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                                <MenuItem value="28800">8 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                                <MenuItem value="21600">6 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                                <MenuItem value="10800">3 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                                <MenuItem value="3600">1 {intl.formatMessage({ id: 'Hour' })}</MenuItem>
                                                                                <MenuItem value="1800">30 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                                <MenuItem value="900">15 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                                <MenuItem value="600">10 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                                <MenuItem value="300">5 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                                <MenuItem value="60">1 {intl.formatMessage({ id: 'Minute' })}</MenuItem>
                                                                                <MenuItem value="30">30 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                                <MenuItem value="15">15 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                                <MenuItem value="10">10 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                                <MenuItem value="5">5 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                            </Select>
                                                                        </Grid>}
                                                            </Grid>
                                                        </Box>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    )
                                } : null ),
                            ((this.state.meterConfig & 0x02) != 0 ?
                                {
                                    tabName: this.state.deviceConfig?.SWversion && semver.gte(this.state.deviceConfig?.SWversion, '2.5.1') ? intl.formatMessage({ id: "Flow / Pulse / Digital Channel B" }) : intl.formatMessage({ id: "Flow Channel B" }),
                                    disabled: !this.state.ready,

                                    tabContent: (
                                        <div>
                                            <div>
                                                {// Channel B
                                                    (this.state.meterConfig & 0x02) != 0 &&
                                                    <div>
                                                            <div>{this.state.deviceConfig?.SWversion && semver.gte(this.state.deviceConfig?.SWversion, '2.5.1') ? intl.formatMessage({ id: "Flow / Digital Channel B" }) : intl.formatMessage({ id: "Flow Channel B" })}</div>
                                                        <Box border={2} padding={3}>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12}>
                                                                        <Switch name="FlowB" size="small" color="secondary" checked={this.state.deviceConfig?.FlowB} onChange={this.handleToggleChange.bind(this)} />{intl.formatMessage({ id: "Enable" })}
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                        {intl.formatMessage({ id: 'Channel Reference' })}
                                                                </Grid>
                                                                <Grid item xs={8}>
                                                                    <TextField name="FlowBRef" fullWidth={false} variant="outlined" size="small" value={this.state.deviceConfig?.FlowBRef} onChange={this.handleTextfieldChange.bind(this)} disabled={!this.state.deviceConfig?.FlowB} />
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    {intl.formatMessage({ id: 'Input Type' })}:
                                                                </Grid>
                                                                <Grid item xs={8}>
                                                                    <Select
                                                                        name="FlowBPulseType"
                                                                        style={{ margin: 0, paddingBottom: 0 }}
                                                                        value={this.state.deviceConfig?.FlowBPulseType}
                                                                        disabled={!this.state.deviceConfig?.FlowB}
                                                                        onChange={this.handleFlowTypeChange.bind(this)}
                                                                    >
                                                                            <MenuItem value={1}>{intl.formatMessage({ id: 'Forward' })}</MenuItem>
                                                                            {/*<MenuItem value={2}>{intl.formatMessage({ id: 'Fwd/Rev' })}</MenuItem>*/}
                                                                            {/*<MenuItem value={3}>{intl.formatMessage({ id: 'Fwd/Dir' })}</MenuItem>*/}
                                                                            {this.state.deviceConfig?.SWversion && semver.gte(this.state.deviceConfig?.SWversion, '2.5.1') && <MenuItem value={17}>{intl.formatMessage({ id: 'Forward (PIT)' })}</MenuItem>}
                                                                            {/*{this.state.deviceConfig?.SWversion && semver.gte(this.state.deviceConfig?.SWversion, '2.5.1') && <MenuItem value={18}>{intl.formatMessage({ id: 'Fwd/Rev (PIT)' })}</MenuItem>}*/}
                                                                            {this.state.deviceConfig?.SWversion && semver.gte(this.state.deviceConfig?.SWversion, '2.5.1') && <MenuItem value={20}>{intl.formatMessage({ id: 'Digital' })}</MenuItem>}
                                                                    </Select>

                                                                </Grid>
                                                                    {(this.state.deviceConfig?.FlowBPulseType != 20) && <Grid item xs={4}>
                                                                        {intl.formatMessage({ id: 'Pulse Multiplier' })}
                                                                    </Grid>}
                                                                    {(this.state.deviceConfig?.FlowBPulseType != 20) && <Grid item xs={8}>
                                                                        <TextField name="FlowBMultiplier"
                                                                            fullWidth={false}
                                                                            variant="outlined"
                                                                            size="small"
                                                                            value={this.state.deviceConfig?.FlowBMultiplierStr}
                                                                            onChange={this.handleTextfieldChange.bind(this)}
                                                                            disabled={!this.state.deviceConfig?.FlowB}
                                                                            error={this.state.fieldErrors.FlowBMultiplier}
                                                                            helperText={this.state.fieldErrors.FlowBMultiplier ? intl.formatMessage({ id: "Must be DECIMAL number" }) : ""}
                                                                        />
                                                                        {console.log(this.state.deviceConfig?.FlowBUnits) }
                                                                        <Select
                                                                            name="FlowBUnits"
                                                                            style={{ margin: 0, paddingBottom: 0 }}
                                                                            size="small"
                                                                            value={this.state.deviceConfig?.FlowBUnits}
                                                                            disabled={!this.state.deviceConfig?.FlowB}
                                                                            onChange={this.handleSelectChange.bind(this)}
                                                                        >
                                                                            <MenuItem value="01">{intl.formatMessage({ id: 'Litres' })}</MenuItem>
                                                                            <MenuItem value="02">{intl.formatMessage({ id: 'M3' })}</MenuItem>
                                                                            <MenuItem value="07">{intl.formatMessage({ id: 'US Gallons' })}</MenuItem>
                                                                            <MenuItem value="08">{intl.formatMessage({ id: 'ft3' })}</MenuItem>
                                                                            <MenuItem value="15">mm</MenuItem>
                                                                            <MenuItem value="16">cm</MenuItem>
                                                                        </Select>
                                                                    </Grid>}
                                                                    {((this.state.orgConfig?.FlowBMultiplierStr !== this.state.deviceConfig?.FlowBMultiplierStr) ||
                                                                        (this.state.orgConfig?.FlowBUnits !== this.state.deviceConfig?.FlowBUnits)) &&
                                                                        <p>{intl.formatMessage({ id: 'Warning! Change the multiplier whilst logging data will dramatically change the graphing function and may be difficult to read for a while' })}</p>
                                                                    }
                                                                <Grid item xs={12}>
                                                                </Grid>
                                                                    {(this.state.deviceConfig?.FlowAPulseType === 1
                                                                        || this.state.deviceConfig?.FlowAPulseType === 2
                                                                        || this.state.deviceConfig?.FlowAPulseType === 3
                                                                        || this.state.deviceConfig?.FlowAPulseType === '1'
                                                                        || this.state.deviceConfig?.FlowAPulseType === '2'
                                                                        || this.state.deviceConfig?.FlowAPulseType === '3'
                                                                    ) && <Grid item xs={4}>
                                                                            {intl.formatMessage({ id: 'Logging Interval' })}
                                                                        </Grid>}
                                                                    {(this.state.deviceConfig?.FlowAPulseType === 1
                                                                        || this.state.deviceConfig?.FlowAPulseType === 2
                                                                        || this.state.deviceConfig?.FlowAPulseType === 3
                                                                        || this.state.deviceConfig?.FlowAPulseType === '1'
                                                                        || this.state.deviceConfig?.FlowAPulseType === '2'
                                                                        || this.state.deviceConfig?.FlowAPulseType === '3'
                                                                    ) && <Grid item xs={8}>
                                                                            <Select
                                                                                name="FlowBSchedule"
                                                                                size="small"
                                                                                style={{ margin: 0, paddingBottom: 0 }}
                                                                                value={this.state.deviceConfig?.FlowBSchedule}
                                                                                disabled={!this.state.deviceConfig?.FlowB}
                                                                                onChange={this.handleSelectChange.bind(this)}
                                                                            >
                                                                                <MenuItem value="43200">12 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                                <MenuItem value="28800">8 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                                <MenuItem value="21600">6 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                                <MenuItem value="10800">3 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                                <MenuItem value="3600">1 {intl.formatMessage({ id: 'Hour' })}</MenuItem>
                                                                                <MenuItem value="1800">30 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                                <MenuItem value="900">15 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                                <MenuItem value="600">10 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                                <MenuItem value="300">5 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                                <MenuItem value="60">1 {intl.formatMessage({ id: 'Minute' })}</MenuItem>
                                                                                <MenuItem value="30">30 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                                <MenuItem value="15">15 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                                <MenuItem value="10">10 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                                <MenuItem value="5">5 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                            </Select>
                                                                        </Grid>}
                                                            </Grid>
                                                        </Box>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    )
                                } : null),
                            ((this.state.meterConfig & 0x04) != 0 ?
                                {
                                    tabName: (this.props.model === 'CHFC' || this.props.model === 'CHCC') ? intl.formatMessage({ id: "Current Channel C" }) : intl.formatMessage({ id: "Pressure Channel C" }),
                                            disabled: !this.state.ready,
                                            tabContent: (
                                                <div>

                                                {// Channel C
                                                    (this.state.meterConfig & 0x04) != 0 &&
                                                        (this.props.model !== 'CHFC' && this.props.model !== 'CHCC' ?
                                                            <div>
                                                                <div>{`${intl.formatMessage({ id: "Pressure Channel 1 - Transducer" })} - ${ this.state.transducer1 } ${intl.formatMessage({ id: 'Bar' })}`}</div>
                                                                <Box border={2} padding={3}>
                                                                    <Grid container spacing={2}>
                                                                        <Grid item xs={12}>
                                                                            <Switch name="AnalogueC" size="small" color="secondary" checked={this.state.deviceConfig?.AnalogueC} onChange={this.handleToggleChange.bind(this)} /> {intl.formatMessage({ id: 'Enable' })}
                                                                        </Grid>
                                                                        
                                                                        <Grid item xs={4}>
                                                                            {intl.formatMessage({ id: 'Channel Ref' })}:
                                                                        </Grid>
                                                                        <Grid item xs={8}>
                                                                            <TextField name="AnalogueCRef" fullWidth={false} variant="outlined" size="small" disabled={!this.state.deviceConfig?.AnalogueC} value={this.state.deviceConfig?.AnalogueCRef} onChange={this.handleTextfieldChange.bind(this)} />
                                                                        </Grid>

                                                                        <Grid item xs={4}>
                                                                            {intl.formatMessage({ id: 'Units' })}
                                                                        </Grid>

                                                                        <Grid item xs={8}>
                                                                            {console.log(this.state.deviceConfig?.AnalogueCUnits) }
                                                                            <Select
                                                                                style={{ margin: 0, paddingBottom: 0 }}
                                                                                value={this.state.deviceConfig?.AnalogueCUnits}
                                                                                
                                                                                name="AnalogueCUnits"
                                                                                disabled={!this.state.deviceConfig?.AnalogueC}
                                                                                onChange={this.handleSelectChange.bind(this)}
                                                                            >
                                                                                <MenuItem value="03">{intl.formatMessage({ id: 'Bar' })}</MenuItem>
                                                                                <MenuItem value="04">{intl.formatMessage({ id: 'millibar' })}</MenuItem>
                                                                                <MenuItem value="05">{intl.formatMessage({ id: 'mH20' })}</MenuItem>
                                                                                <MenuItem value="06">{intl.formatMessage({ id: 'psi' })}</MenuItem>
                                                                                <MenuItem value="12">{intl.formatMessage({ id: 'kilopascals (kPa)' })}</MenuItem>
                                                                                <MenuItem value="13">{intl.formatMessage({ id: 'Feet Head (ftH2O)' })}</MenuItem>
                                                                                <MenuItem value="14">{intl.formatMessage({ id: 'Kg/cm²'})}</MenuItem>
                                                                            </Select>
                                                                        </Grid>
                                                                        <Grid item xs={4}>
                                                                            {intl.formatMessage({ id: 'Logging Interval' })}
                                                                        </Grid>
                                                                        
                                                                        <Grid item xs={8}>
                                                                            <Select
                                                                                name="AnalogueCSchedule"
                                                                                size="small"
                                                                                style={{ margin: 0, paddingBottom: 0 }}
                                                                                value={this.state.deviceConfig?.AnalogueCSchedule}
                                                                                disabled={!this.state.deviceConfig?.AnalogueC}
                                                                                onChange={this.handleSelectChange.bind(this)}
                                                                            >
                                                                                <MenuItem value="43200">12 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                                <MenuItem value="28800">8 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                                <MenuItem value="21600">6 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                                <MenuItem value="10800">3 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                                <MenuItem value="3600">1 {intl.formatMessage({ id: 'Hour' })}</MenuItem>
                                                                                <MenuItem value="1800">30 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                                <MenuItem value="900">15 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                                <MenuItem value="600">10 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                                <MenuItem value="300">5 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                                <MenuItem value="60">1 {intl.formatMessage({ id: 'Minute' })}</MenuItem>
                                                                                <MenuItem value="30">30 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                                <MenuItem value="10">10 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                                <MenuItem value="5">5 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                            </Select>
                                                                        </Grid>
                                                                        <Grid item xs={4} visibility="hidden">
                                                                            {intl.formatMessage({ id: 'Multiplier' })}:
                                                                        </Grid>
                                                                            <Grid item xs={8} visibility="hidden">
                                                                                <TextField name="AnalogueCMultiplier"
                                                                                    fullWidth={false}
                                                                                    variant="outlined"
                                                                                    size="small"
                                                                                    disabled={!this.state.deviceConfig?.AnalogueC}
                                                                                    value={this.state.deviceConfig?.AnalogueCMultiplierStr}
                                                                                    onChange={this.handleTextfieldChange.bind(this)}
                                                                                    error={this.state.fieldErrors.AnalogueCMultiplier}
                                                                                    helperText={this.state.fieldErrors.AnalogueCMultiplier ? intl.formatMessage({ id: "Must be DECIMAL number" }) : ""}
                                                                                />
                                                                            </Grid>
                                                                            {this.is2FlowChariot(this.state.deviceConfig?.SWversion) &&
                                                                                <Grid item xs={12}>
                                                                                    <Grid container spacing={2}>
                                                                                        <Grid item xs={12}>
                                                                                                <Switch name="AnalogueCSample" size="small" color="secondary" checked={this.state.deviceConfig?.AnalogueCSample && this.state.deviceConfig?.AnalogueCSample > 0} onChange={this.handleToggleChange.bind(this)} />{intl.formatMessage({ id: 'Enable Sampling' })}
                                                                                    </Grid>
                                                                                        <Grid item xs={4}>
                                                                                            {intl.formatMessage({ id: 'Sampling Interval' })}
                                                                                        </Grid>
                                                                                        <Grid item xs={8}>
                                                                                            <Select
                                                                                                name="AnalogueCSampleTime"
                                                                                                size="small"
                                                                                                style={{ margin: 0, paddingBottom: 0 }}
                                                                                                value={this.state.deviceConfig?.AnalogueCSampleTime}
                                                                                                disabled={this.state.deviceConfig?.AnalogueCSample == 0}
                                                                                                onChange={this.handleSelectChange.bind(this)}
                                                                                                >
                                                                                                    {this.generateSamplingIntervals(this.state.deviceConfig?.AnalogueCSchedule).map((v: { value: string, label: string }) => {
                                                                                                        return <MenuItem value={v.value} key={v.value}>{v.label}</MenuItem>
                                                                                                    })
                                                                                                    }
                                                                                            </Select>
                                                                                            </Grid>
                                                                                            {/*<Grid item xs={4}>*/}
                                                                                            {/*    {intl.formatMessage({id: 'Enable Min/Max Sampling'})}*/}
                                                                                            {/*</Grid>*/}
                                                                                            {/*<Grid item xs={8}>*/}
                                                                                            {/*    <Switch name="AnalogueCSampleType" checked={this.state.deviceConfig?.AnalogueCSampleType === 1} disabled={this.state.deviceConfig?.AnalogueCSample == 0} onChange={this.handleToggleChange.bind(this)} />*/}
                                                                                            {/*</Grid>*/}
                                                                                        </Grid>
                                                                                    </Grid>
                                                                        }
                                                                        
                                                                    </Grid>
                                                                </Box>
                                                            </div> :
                                                            <div>
                                                                <div>{intl.formatMessage({ id: "4-20mA Channel C" })}</div>
                                                                <Box border={2} padding={3}>
                                                                    <Grid container spacing={2}>
                                                                        <Grid item xs={4}>
                                                                            <Switch name="AnalogueC" size="small" color="secondary" checked={this.state.deviceConfig?.AnalogueC} onChange={this.handleToggleChange.bind(this)} /> {intl.formatMessage({ id: 'Enable' })}
                                                                        </Grid>
                                                                        <Grid xs={8}>
                                                                            {this.state.transducer1 != null &&
                                                                                <div>
                                                                                    {this.state.transducer1} {intl.formatMessage({ id: 'Bar' })}
                                                                                </div>
                                                                            }
                                                                        </Grid>
                                                                        <Grid item xs={4}>
                                                                            {intl.formatMessage({ id: 'Channel Ref' })}:
                                                                        </Grid>
                                                                        <Grid item xs={8}>
                                                                            <TextField name="AnalogueCRef" fullWidth={false} variant="outlined" size="small" disabled={!this.state.deviceConfig?.AnalogueC} value={this.state.deviceConfig?.AnalogueCRef} onChange={this.handleTextfieldChange.bind(this)} />
                                                                        </Grid>
                                                                        <Grid item xs={4}>
                                                                            {intl.formatMessage({ id: 'Logging Interval' })}
                                                                        </Grid>
                                                                        <Grid item xs={8}>
                                                                            <Select
                                                                                name="AnalogueCSchedule"
                                                                                size="small"
                                                                                style={{ margin: 0, paddingBottom: 0 }}
                                                                                value={this.state.deviceConfig?.AnalogueCSchedule}
                                                                                disabled={!this.state.deviceConfig?.AnalogueC}
                                                                                onChange={this.handleSelectChange.bind(this)}
                                                                            >
                                                                                <MenuItem value="43200">12 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                                <MenuItem value="28800">8 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                                <MenuItem value="21600">6 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                                <MenuItem value="10800">3 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                                <MenuItem value="3600">1 {intl.formatMessage({ id: 'Hour' })}</MenuItem>
                                                                                <MenuItem value="1800">30 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                                <MenuItem value="900">15 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                                <MenuItem value="600">10 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                                <MenuItem value="300">5 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                                <MenuItem value="60">1 {intl.formatMessage({ id: 'Minute' })}</MenuItem>
                                                                                <MenuItem value="30">30 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                                <MenuItem value="10">10 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                                <MenuItem value="5">5 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                            </Select>
                                                                        </Grid>
                                                                        <Grid item xs={4}>
                                                                            {intl.formatMessage({ id: 'Units' })}:
                                                                        </Grid>
                                                                        <Grid item xs={8}>
                                                                            {console.log(inputUnits[this.state.deviceConfig?.AnalogueCUnits], this.state.deviceConfig?.AnalogueCUnits) }
                                                                            <Select
                                                                                native
                                                                                disabled={!this.state.deviceConfig?.AnalogueC}
                                                                                value={this.state.deviceConfig?.AnalogueCUnits}
                                                                                size="small"
                                                                                name="AnalogueCUnits"
                                                                                onChange={this.handleTextfieldChange.bind(this)}
                                                                            >
                                                                                {this.buildUnitCategories(inputUnits)}

                                                                            </Select>
                                                                        </Grid>
                                                                        <Grid item xs={4} visibility="visible">
                                                                            {intl.formatMessage({ id: 'Min Value' })}:
                                                                        </Grid>
                                                                        <Grid item xs={8} visibility="visible">
                                                                            <div style={{ display: "flex" }}>
                                                                                <TextField
                                                                                    name="AnalogueCMapMin"
                                                                                    value={this.state.deviceConfig?.AnalogueCMapMin}
                                                                                    size="small"
                                                                                    onChange={this.handleNumericChange.bind(this)}
                                                                                    variant="outlined"
                                                                                    disabled={!this.state.deviceConfig?.AnalogueC}
                                                                                />
                                                                                <h4 style={{ margin: "6px 0 0 10px" }}>{inputUnits[this.state.deviceConfig?.AnalogueCUnits]?.name}</h4>
                                                                            </div>
                                                                        </Grid>
                                                                        <Grid item xs={4} visibility="visible">
                                                                            {intl.formatMessage({ id: 'Max Value' })}:
                                                                        </Grid>
                                                                        <Grid item xs={8} visibility="visible">
                                                                            <div style={{ display: "flex" }}>
                                                                                <div style={{ display: "flex" }}>
                                                                                    <TextField
                                                                                        name="AnalogueCMapMax"
                                                                                        value={this.state.deviceConfig?.AnalogueCMapMax}
                                                                                        size="small"
                                                                                        onChange={this.handleNumericChange.bind(this)}
                                                                                        variant="outlined"
                                                                                        disabled={!this.state.deviceConfig?.AnalogueC}
                                                                                    />
                                                                                    <h4 style={{ margin: "6px 0 0 10px" }}>{inputUnits[this.state.deviceConfig?.AnalogueCUnits]?.name}</h4>
                                                                                </div>
                                                                            </div>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Box>
                                                            </div>)
                                                }
                                                </div>
                                        )
                                } : null),
                            ((this.state.meterConfig & 0x08) != 0 ?
                                {
                                    tabName: (this.props.model === 'CHFC' || this.props.model === 'CHCC') ? intl.formatMessage({ id: "Current Channel D" }) : intl.formatMessage({ id: "Pressure Channel D" }),
                                        disabled: !this.state.ready,
                                        tabContent: (
                                            <div>
                                                {// Channel D
                                                    (this.state.meterConfig & 0x08) != 0 &&
                                                    (this.props.model !== 'CHFC' && this.props.model !== 'CHCC' ?
                                                    <div>
                                                        <div>{`${intl.formatMessage({ id: "Pressure Channel 2 - Transducer" })} - ${this.state.transducer2} ${intl.formatMessage({ id: 'Bar' })}`}</div>
                                                        <Box border={2} padding={3}>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12}>
                                                                        <Switch name="AnalogueD" size="small" color="secondary" checked={this.state.deviceConfig?.AnalogueD} onChange={this.handleToggleChange.bind(this)} />{intl.formatMessage({ id: 'Enable' })}
                                                                </Grid>
                                                               
                                                                 <Grid item xs={4}>
                                                                    {intl.formatMessage({ id: 'Channel Ref' })}:
                                                                </Grid>
                                                                <Grid item xs={8}>
                                                                    <TextField name="AnalogueDRef" fullWidth={false} variant="outlined" size="small" disabled={!this.state.deviceConfig?.AnalogueD} value={this.state.deviceConfig?.AnalogueDRef} onChange={this.handleTextfieldChange.bind(this)} />
                                                                </Grid>

                                                                <Grid item xs={4}>
                                                                    {intl.formatMessage({ id: 'Units' })}
                                                                </Grid>
                                                                <Grid item xs={8}>
                                                                    <Select
                                                                        style={{ margin: 0, paddingBottom: 0 }}
                                                                        value={this.state.deviceConfig?.AnalogueDUnits}
                                                                        name="AnalogueDUnits"
                                                                        disabled={!this.state.deviceConfig?.AnalogueD}
                                                                        onChange={this.handleSelectChange.bind(this)}
                                                                        >
                                                                            <MenuItem value="03">{intl.formatMessage({ id: 'Bar' })}</MenuItem>
                                                                            <MenuItem value="04">{intl.formatMessage({ id: 'millibar' })}</MenuItem>
                                                                            <MenuItem value="05">{intl.formatMessage({ id: 'mH20' })}</MenuItem>
                                                                            <MenuItem value="06">{intl.formatMessage({ id: 'psi' })}</MenuItem>
                                                                            <MenuItem value="12">{intl.formatMessage({ id: 'kilopascals (kPa)' })}</MenuItem>
                                                                            <MenuItem value="13">{intl.formatMessage({ id: 'Feet Head (ftH2O)' })}</MenuItem>
                                                                            <MenuItem value="14">{intl.formatMessage({ id: 'Kg/cm²' })}</MenuItem>
                                                                    </Select>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    {intl.formatMessage({ id: 'Logging Interval' })}
                                                                </Grid>
                                                                <Grid item xs={8}>
                                                                    <Select
                                                                        name="AnalogueDSchedule"
                                                                        size="small"
                                                                        style={{ margin: 0, paddingBottom: 0 }}
                                                                        value={this.state.deviceConfig?.AnalogueDSchedule}
                                                                        disabled={!this.state.deviceConfig?.AnalogueD}
                                                                        onChange={this.handleSelectChange.bind(this)}
                                                                    >
                                                                        <MenuItem value="43200">12 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                        <MenuItem value="28800">8 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                        <MenuItem value="21600">6 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                        <MenuItem value="10800">3 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                        <MenuItem value="3600">1 {intl.formatMessage({ id: 'Hour' })}</MenuItem>
                                                                        <MenuItem value="1800">30 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                        <MenuItem value="900">15 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                        <MenuItem value="600">10 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                        <MenuItem value="300">5 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                        <MenuItem value="60">1 {intl.formatMessage({ id: 'Minute' })}</MenuItem>
                                                                        <MenuItem value="30">30 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                        <MenuItem value="10">10 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                        <MenuItem value="5">5 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                    </Select>
                                                                </Grid>
                                                                <Grid item xs={4} visibility="hidden">
                                                                    {intl.formatMessage({ id: 'Multiplier' })}:
                                                                </Grid>
                                                                <Grid item xs={8} visibility="hidden">
                                                                    <TextField name="AnalogueDMultiplier"
                                                                        fullWidth={false}
                                                                        variant="outlined"
                                                                        size="small"
                                                                        disabled={!this.state.deviceConfig?.AnalogueD}
                                                                        value={this.state.deviceConfig?.AnalogueDMultiplier}
                                                                        onChange={this.handleTextfieldChange.bind(this)}
                                                                        error={this.state.fieldErrors.AnalogueDMultiplier}
                                                                        helperText={this.state.fieldErrors.AnalogueDMultiplier ? intl.formatMessage({ id: "Must be DECIMAL number" }) : ""}
                                                                    />
                                                                </Grid>
                                                                    {this.is2FlowChariot(this.state.deviceConfig?.SWversion) &&
                                                                        <Grid item xs={12}>
                                                                            <Grid container spacing={2}>
                                                                                <Grid item xs={12}>
                                                                                    <Switch name="AnalogueDSample" size="small" color="secondary" checked={this.state.deviceConfig?.AnalogueDSample && this.state.deviceConfig?.AnalogueDSample > 0} onChange={this.handleToggleChange.bind(this)} /> {intl.formatMessage({ id: 'Enable Sampling' })}
                                                                                </Grid>
                                                                                <Grid item xs={4}>
                                                                                    {intl.formatMessage({ id: 'Sampling Interval' })}
                                                                                </Grid>

                                                                                <Grid item xs={8}>
                                                                                    <Select
                                                                                        name="AnalogueDSampleTime"
                                                                                        size="small"
                                                                                        style={{ margin: 0, paddingBottom: 0 }}
                                                                                        value={this.state.deviceConfig?.AnalogueDSampleTime}
                                                                                        disabled={this.state.deviceConfig?.AnalogueDSample == 0}
                                                                                        onChange={this.handleSelectChange.bind(this)}
                                                                                    >
                                                                                        {this.generateSamplingIntervals(this.state.deviceConfig?.AnalogueDSchedule).map((v: {value: string, label: string}) =>
                                                                                        {
                                                                                            return <MenuItem value={v.value} key={v.value}>{v.label}</MenuItem>
                                                                                        })
                                                                                        }
                                                                                    </Select>
                                                                                </Grid>
                                                                                {/*<Grid item xs={4}>*/}
                                                                                {/*    {intl.formatMessage({ id: 'Enable Min/Max Sampling' })}*/}
                                                                                {/*</Grid>*/}
                                                                                {/*<Grid item xs={8}>*/}
                                                                                {/*    <Switch name="AnalogueDSampleType" checked={this.state.deviceConfig?.AnalogueDSampleType === 1} disabled={this.state.deviceConfig?.AnalogueDSample == 0} onChange={this.handleToggleChange.bind(this)} />*/}

                                                                                {/*</Grid>*/}
                                                                            </Grid>
                                                                        </Grid>

                                                                    }
                                                            </Grid>
                                                        </Box>
                                                        </div> : 
                                                        <div>
                                                            <div>{intl.formatMessage({ id: "4-20mA Channel D" })}</div>
                                                            <Box border={2} padding={3}>
                                                                <Grid container spacing={2}>
                                                                    <Grid item xs={4}>
                                                                        <Switch name="AnalogueD" size="small" color="secondary" checked={this.state.deviceConfig?.AnalogueD} onChange={this.handleToggleChange.bind(this)} /> {intl.formatMessage({ id: 'Enable' })}
                                                                    </Grid>
                                                                    <Grid xs={8}>
                                                                        {this.state.transducer1 != null &&
                                                                            <div>
                                                                                {this.state.transducer1} {intl.formatMessage({ id: 'Bar' })}
                                                                            </div>
                                                                        }
                                                                    </Grid>
                                                                    <Grid item xs={4}>
                                                                        {intl.formatMessage({ id: 'Channel Ref' })}:
                                                                    </Grid>
                                                                    <Grid item xs={8}>
                                                                        <TextField name="AnalogueDRef" fullWidth={false} variant="outlined" size="small" disabled={!this.state.deviceConfig?.AnalogueD} value={this.state.deviceConfig?.AnalogueDRef} onChange={this.handleTextfieldChange.bind(this)} />
                                                                    </Grid>
                                                                    <Grid item xs={4}>
                                                                        {intl.formatMessage({ id: 'Logging Interval' })}
                                                                    </Grid>
                                                                    <Grid item xs={8}>
                                                                        <Select
                                                                            name="AnalogueDSchedule"
                                                                            size="small"
                                                                            style={{ margin: 0, paddingBottom: 0 }}
                                                                            value={this.state.deviceConfig?.AnalogueDSchedule}
                                                                            disabled={!this.state.deviceConfig?.AnalogueD}
                                                                            onChange={this.handleSelectChange.bind(this)}
                                                                        >
                                                                            <MenuItem value="43200">12 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                            <MenuItem value="28800">8 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                            <MenuItem value="21600">6 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                            <MenuItem value="10800">3 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                                                                            <MenuItem value="3600">1 {intl.formatMessage({ id: 'Hour' })}</MenuItem>
                                                                            <MenuItem value="1800">30 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                            <MenuItem value="900">15 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                            <MenuItem value="600">10 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                            <MenuItem value="300">5 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                                                                            <MenuItem value="60">1 {intl.formatMessage({ id: 'Minute' })}</MenuItem>
                                                                            <MenuItem value="30">30 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                            <MenuItem value="10">10 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                            <MenuItem value="5">5 {intl.formatMessage({ id: 'Seconds' })}</MenuItem>
                                                                        </Select>
                                                                    </Grid>
                                                                    <Grid item xs={4}>
                                                                        {intl.formatMessage({ id: 'Units' })}:
                                                                    </Grid>
                                                                    <Grid item xs={8}>
                                                                        <Select
                                                                            native
                                                                            value={this.state.deviceConfig?.AnalogueDUnits}
                                                                            size="small"
                                                                            disabled={!this.state.deviceConfig?.AnalogueD}
                                                                            name="AnalogueDUnits"
                                                                            onChange={this.handleTextfieldChange.bind(this)}
                                                                        >
                                                                            {this.buildUnitCategories(inputUnits)}
                                                                        </Select>
                                                                    </Grid>
                                                                    <Grid item xs={4} visibility="visible">
                                                                        {intl.formatMessage({ id: 'Min Value' })}:
                                                                    </Grid>
                                                                    <Grid item xs={8} visibility="visible">
                                                                        <div style={{display: "flex"} }>
                                                                            <TextField
                                                                                name="AnalogueDMapMin"
                                                                                value={this.state.deviceConfig?.AnalogueDMapMin}
                                                                                size="small"
                                                                                onChange={this.handleNumericChange.bind(this)}
                                                                                variant="outlined"
                                                                                disabled={!this.state.deviceConfig?.AnalogueD}
                                                                            />
                                                                            <h4 style={{ margin: "6px 0 0 10px" }}>{inputUnits[this.state.deviceConfig?.AnalogueDUnits]?.name}</h4>
                                                                        </div>
                                                                    </Grid>
                                                                    <Grid item xs={4} visibility="visible">
                                                                        {intl.formatMessage({ id: 'Max Value' })}:
                                                                    </Grid>
                                                                    <Grid item xs={8} visibility="visible">
                                                                        <div style={{ display: "flex" }}>
                                                                            <div style={{ display: "flex" }}>
                                                                                <TextField
                                                                                    name="AnalogueDMapMax"
                                                                                    value={this.state.deviceConfig?.AnalogueDMapMax}
                                                                                    size="small"
                                                                                    onChange={this.handleNumericChange.bind(this)}
                                                                                    variant="outlined"
                                                                                    disabled={!this.state.deviceConfig?.AnalogueD}
                                                                                />
                                                                                <h4 style={{ margin: "6px 0 0 10px" }}>{inputUnits[this.state.deviceConfig?.AnalogueDUnits]?.name}</h4>
                                                                            </div>
                                                                        </div>
                                                                    </Grid>
                                                                </Grid>
                                                            </Box>
                                                        </div>)
                                                }
                                            </div>
                                        )
                                } : null),
                            //    {
                            //    tabName: intl.formatMessage({ id: "Alarms" }),
                            //    disabled: !this.state.ready,
                            //    tabContent: (
                            //        <div>
                            //            {this.state.alarmTab == 0 ?
                            //                <div>
                            //                    <b>{intl.formatMessage({ id: 'Double click row to edit alarm details' })}</b>
                            //                </div>
                            //                :
                            //                <div>
                            //                    {window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: "Use Save to update alarm settings. ALl alarms are processed on ZONELOG and any changes will take immediate effect." }) : intl.formatMessage({ id: "Use Save to update alarm settings. NOTE: Chariot alarms are processed on Aquaguard and any changes will take immediate effect." })}
                            //                </div>
                            //            }
                            //            <CustomTabs
                            //                headerColor="primary"
                            //                plainTabs
                            //                value={this.state.alarmTab}
                            //                onChange={():void => this.handleAlarmTabChange()}
                            //                tabs={[
                            //                    {
                            //                        tabName: intl.formatMessage({ id: "List" }),
                            //                        tabContent: (
                            //                            <div>
                            //                                <Box border={2} padding={3}>
                            //                                    <Button variant="contained" style={{ margin: "10px 0" }} onClick={(): void => this.handleCreateAlarms()}>{intl.formatMessage({ id: 'Create New Alarm' })}</Button>
                            //                                    <h5>{intl.formatMessage({ id: 'Double Click on any alarm spaces to edit the alarm' })}</h5>

                            //                                    <DataGrid
                            //                                        dataSource={this.state.alarms}
                            //                                        keyExpr="Idx"
                            //                                        onRowDblClick={(e):void => this.handleAlarmRowDblClick(e.data.Idx)}
                            //                                    >
                            //                                        <Selection mode="single" />
                            //                                        <Column dataField="Idx" dataType="number" width={40} />
                            //                                        <Column dataField="AlarmMessage" dataType="string" caption={intl.formatMessage({id: 'Alarm Message'}) } />
                            //                                        <Column dataField="AlarmClass" dataType="string" customizeText={(data) => this.classColumnCustomizeText(data, intl)} caption={intl.formatMessage({id: 'Alarm Class'}) } />
                            //                                        <Column dataField="SetInput" dataType="string" customizeText={(data) => this.inputColumnCustomizeText(data, intl)} caption={intl.formatMessage({ id: 'Set Input' })} />
                            //                                        <Column dataField="ClrInput" dataType="string" customizeText={(data) => this.inputColumnCustomizeText(data, intl)} caption={intl.formatMessage({ id: 'Clear Input' })} />
                            //                                        <Column dataField="SetThreshold" dataType="number" caption={intl.formatMessage({ id: 'Set Threshold' })}  />
                            //                                        <Column dataField="ClrThreshold" dataType="number" caption={intl.formatMessage({ id: 'Clear Threshold' })} />
                            //                                        <Column dataField="Unit" dataType="string" caption={intl.formatMessage({ id: 'Unit' })} />
                            //                                        </DataGrid>
                                                                
                            //                                </Box>
                            //                            </div>
                            //                        )
                            //                    },
                            //                    {
                            //                        tabName: intl.formatMessage({ id: "Details" }),
                            //                        disabled: !this.state.editAlarm,
                            //                        tabContent: (
                            //                            <div>
                            //                                <Box border={2} padding={3}>
                            //                                    <Grid container spacing={2}>
                            //                                        <Grid item xs={2}>
                            //                                            <Typography sx={{ ml: 2, flex: 1 }} variant="h4" component="div">
                            //                                                {intl.formatMessage({ id: 'Alarm' })} {this.state.editAlarm?.Idx}
                            //                                            </Typography>
                            //                                        </Grid>
                            //                                        <Grid item xs={12}><h5>{intl.formatMessage({ id: 'Set Alarm' })} {this.state.editAlarm?.Idx}</h5></Grid>
                            //                                        <Grid item xs={3}>
                            //                                            <TooltipMaterial title={intl.formatMessage({ id: "This sets the type of alarm you would like on this logger" })} placement="top" >
                            //                                            <FormControl fullWidth>
                            //                                                    <InputLabel id="input-select-label">{intl.formatMessage({ id: 'Set Alarm Type' })}</InputLabel>
                            //                                                <Select
                            //                                                    name="SetInput"
                            //                                                    label="Set Input"
                            //                                                    labelId="input-select-label"
                            //                                                    size="small"
                            //                                                    style={{ margin: 0, paddingBottom: 0 }}
                            //                                                    value={this.state.editAlarm?.SetInput}
                            //                                                    onChange={this.handleAlarmSelectChange.bind(this)}
                            //                                                >
                            //                                                        <MenuItem value="0">{intl.formatMessage({ id: 'Alarm Off' })}</MenuItem>
                            //                                                    {(this.state.channelsAvail & 0x01) != 0 &&
                            //                                                        <MenuItem value="1">{intl.formatMessage({ id: 'Flow A' })}</MenuItem>
                            //                                                    }
                            //                                                    {(this.state.channelsAvail & 0x01) != 0 &&
                            //                                                        <MenuItem value="21">{intl.formatMessage({ id: 'Consumption A' })}</MenuItem>
                            //                                                    }
                            //                                                    {(this.state.channelsAvail & 0x04) != 0 &&
                            //                                                        <MenuItem value="3">{intl.formatMessage({ id: 'Latest Pressure C' })}</MenuItem>
                            //                                                    }
                            //                                                    {(this.state.channelsAvail & 0x04) != 0 &&
                            //                                                        <MenuItem value="11">{intl.formatMessage({ id: 'Pressure C Difference'})}</MenuItem>
                            //                                                    }
                            //                                                    {(this.state.channelsAvail & 0x08) != 0 &&
                            //                                                        <MenuItem value="7">{intl.formatMessage({ id: 'Latest Pressure D' })}</MenuItem>
                            //                                                    }
                            //                                                    {(this.state.channelsAvail & 0x08) != 0 &&
                            //                                                        <MenuItem value="12">{intl.formatMessage({ id: 'Pressure D Difference' })}</MenuItem>
                            //                                                    }
                            //                                                    {(this.state.channelsAvail & 0x02) != 0 &&
                            //                                                        <MenuItem value="9">{intl.formatMessage({ id: 'Flow B' })}</MenuItem>
                            //                                                    }
                            //                                                    {(this.state.channelsAvail & 0x02) != 0 &&
                            //                                                        <MenuItem value="22">{intl.formatMessage({ id: 'Consumption B' })}</MenuItem>
                            //                                                    }
                            //                                                        <MenuItem value="30">{intl.formatMessage({ id: 'Signal Strength' })} (0-31)</MenuItem>
                            //                                                        <MenuItem value="31">{intl.formatMessage({ id: 'Battery' })} (mV)</MenuItem>
                            //                                                </Select>
                            //                                                </FormControl>
                            //                                            </TooltipMaterial>
                            //                                        </Grid>
                            //                                        <Grid item xs={3}>
                            //                                            <TooltipMaterial placement="top" title={intl.formatMessage({ id: "This sets the condition of how that alarm will be triggered from the level in the next box (e.g. Consumption 'IS LESS THAN' 10 l/s )" })} >
                            //                                            <FormControl fullWidth>
                            //                                                    <InputLabel id="operator-select-label">{intl.formatMessage({ id: 'Set Alarm Condition' })}</InputLabel>
                            //                                                <Select
                            //                                                    name="SetOperator"
                            //                                                    label="Set Operator"
                            //                                                    labelId="operator-select-label"
                            //                                                    size="small"
                            //                                                    style={{ margin: 0, paddingBottom: 0 }}
                            //                                                    value={this.state.editAlarm?.SetOperator}
                            //                                                    onChange={this.handleAlarmSelectChange.bind(this)}
                            //                                                >
                            //                                                    <MenuItem value="0">{intl.formatMessage({ id: 'Alarm Off' })}</MenuItem>
                            //                                                    <MenuItem value="1">{intl.formatMessage({ id: 'is Equal to' })}</MenuItem>
                            //                                                    <MenuItem value="2">{intl.formatMessage({ id: 'is Not Equal to' })}</MenuItem>
                            //                                                    <MenuItem value="3">{intl.formatMessage({ id: 'is Less than' })}</MenuItem>
                            //                                                    <MenuItem value="4">{intl.formatMessage({ id: 'is Greater than' })}</MenuItem>
                            //                                                    <MenuItem value="5">{intl.formatMessage({ id: 'is Less than or equal to' })}</MenuItem>
                            //                                                    <MenuItem value="6">{intl.formatMessage({ id: 'is Greater than or equal to' })}</MenuItem>
                            //                                                </Select>
                            //                                                </FormControl>
                            //                                            </TooltipMaterial>
                            //                                        </Grid>
                            //                                        <Grid item xs={2}>
                            //                                            <TooltipMaterial title={intl.formatMessage({ id: "This sets the input value for the alarm (e.g. Consumption is greater than '10')" })} >
                            //                                                <div>
                            //                                                    <TextField name="SetThreshold"
                            //                                                        label={intl.formatMessage({ id: "Set Alarm level" })}
                                                                                    
                            //                                                        fullWidth={true}
                            //                                                        variant="outlined"
                            //                                                        size="small"
                            //                                                        value={this.state.editAlarm?.SetThresholdStr}
                            //                                                        onChange={this.handleAlarmTextfieldChange.bind(this)}
                            //                                                        error={this.state.fieldErrors.SetThreshold}
                            //                                                        helperText={this.state.fieldErrors.SetThreshold ? intl.formatMessage({ id: "Must be DECIMAL number" }) : ""}
                            //                                                    />
                            //                                                    {/*{this.displayUnits(this.state.editAlarm?.SetInput, this.state.setUnits)}*/}
                            //                                                </div>
                            //                                            </TooltipMaterial>
                            //                                        </Grid>
                            //                                        <Grid item xs={1}>

                            //                                            <FormControl fullWidth>
                            //                                                <InputLabel id="unit-select-label">{intl.formatMessage({ id: 'Set Unit' })}</InputLabel>
                            //                                            <Select
                            //                                                    label="Set Unit"
                            //                                                    size="small"
                            //                                                    value={this.state.editAlarm?.Unit}
                            //                                                    labelId="unit-select-label"
                            //                                                    onChange={(e): void => this.handelTempAlarmUnitChange(e) }
                            //                                                    disabled={this.state.editAlarm?.SetInput === 30 || this.state.editAlarm?.SetInput === 31 }
                            //                                            >
                            //                                                {(this.state.editAlarm?.SetInput === 1 || this.state.editAlarm?.SetInput === 9) && <MenuItem value='l/s'>l/s</MenuItem>}
                            //                                                {(this.state.editAlarm?.SetInput === 1 || this.state.editAlarm?.SetInput === 9) && <MenuItem value='m3/h'>m3/h</MenuItem>}
                            //                                                {(this.state.editAlarm?.SetInput === 1 || this.state.editAlarm?.SetInput === 9) && <MenuItem value='gpm'>gpm</MenuItem>}
                            //                                                {(this.state.editAlarm?.SetInput === 1 || this.state.editAlarm?.SetInput === 9) && <MenuItem value='MGD'>MGD</MenuItem>}
                            //                                                {(this.state.editAlarm?.SetInput === 1 || this.state.editAlarm?.SetInput === 9) && <MenuItem value='gps'>gps</MenuItem>}
                            //                                                {(this.state.editAlarm?.SetInput === 1 || this.state.editAlarm?.SetInput === 9) && <MenuItem value='cfs'>cfs</MenuItem>}
                            //                                                {(this.state.editAlarm?.SetInput === 22 || this.state.editAlarm?.SetInput === 21) && <MenuItem value='l'>l</MenuItem>}
                            //                                                {(this.state.editAlarm?.SetInput === 22 || this.state.editAlarm?.SetInput === 21) && <MenuItem value='m3'>m3</MenuItem>}
                            //                                                {(this.state.editAlarm?.SetInput === 3 || this.state.editAlarm?.SetInput === 11 || this.state.editAlarm?.SetInput === 7 || this.state.editAlarm?.SetInput === 12) && <MenuItem value='bar'>bar</MenuItem>}
                            //                                                {(this.state.editAlarm?.SetInput === 3 || this.state.editAlarm?.SetInput === 11 || this.state.editAlarm?.SetInput === 7 || this.state.editAlarm?.SetInput === 12) && <MenuItem value='mb'>millibar</MenuItem>}
                            //                                                {(this.state.editAlarm?.SetInput === 3 || this.state.editAlarm?.SetInput === 11 || this.state.editAlarm?.SetInput === 7 || this.state.editAlarm?.SetInput === 12) && <MenuItem value='mH2O'>mH2O</MenuItem>}
                            //                                                {(this.state.editAlarm?.SetInput === 3 || this.state.editAlarm?.SetInput === 11 || this.state.editAlarm?.SetInput === 7 || this.state.editAlarm?.SetInput === 12) && <MenuItem value='psi'>psi</MenuItem>}
                            //                                                {this.state.editAlarm?.SetInput === 31 && <MenuItem value='mV'>mV</MenuItem>}
                            //                                                {this.state.editAlarm?.SetInput === 30 && <MenuItem value='N/A'>N/A</MenuItem>}
                            //                                                </Select>
                            //                                            </FormControl>
                            //                                        </Grid>
                            //                                        <Grid item xs={3}>
                            //                                            <TooltipMaterial placement="top" title="Sets the interval of how long this metric must happen before alarm is sent">
                            //                                                <FormControl fullWidth>
                            //                                                    <InputLabel id="timeframe-select-label">{intl.formatMessage({ id: 'Set Alarm Timeframe' })}</InputLabel>
                            //                                                    <Select
                            //                                                        name="SetCountStr"
                            //                                                        label="Set Alarm Timeframe"
                            //                                                        labelId="timeframe-select-label"
                            //                                                        size="small"
                            //                                                        style={{ margin: 0, paddingBottom: 0 }}
                            //                                                        value={this.state.editAlarm?.SetCountStr}
                            //                                                        onChange={this.handleAlarmSelectChange.bind(this)}
                            //                                                    >
                            //                                                        <MenuItem value="5mins">{intl.formatMessage({ id: 'every' })} 5 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                            //                                                        <MenuItem value="15mins">{intl.formatMessage({ id: 'every' })} 15 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                            //                                                        <MenuItem value="30mins">{intl.formatMessage({ id: 'every' })} 30 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                            //                                                        <MenuItem value="1hour">{intl.formatMessage({ id: 'every' })} {intl.formatMessage({ id: 'Hour' })}</MenuItem>
                            //                                                        <MenuItem value="3hour">{intl.formatMessage({ id: 'every' })} 3 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                            //                                                        <MenuItem value="6hour">{intl.formatMessage({ id: 'every' })} 6 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                            //                                                        <MenuItem value="12hour">{intl.formatMessage({ id: 'every' })} 12 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                            //                                                        <MenuItem value="24hour">{intl.formatMessage({ id: 'every' })} 24 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                            //                                                    </Select>
                            //                                                </FormControl>
                            //                                            </TooltipMaterial>
                            //                                        </Grid>
                                                                    
                            //                                        <Grid item xs={12}><h5>Clear Alarm {this.state.editAlarm?.Idx}</h5></Grid>
                            //                                        <Grid item xs={3}>
                            //                                            <TooltipMaterial placement="top" title={intl.formatMessage({ id: "This sets the type of method to clear this alarm" })} >
                            //                                            <FormControl fullWidth>
                            //                                                    <InputLabel id="input-select-label">{intl.formatMessage({ id: 'Clear Alarm Type' })}</InputLabel>
                            //                                                <Select
                            //                                                    name="ClrInput"
                            //                                                    label="ClrInput"
                            //                                                    labelId="input-select-label"
                            //                                                    size="small"
                            //                                                    style={{ margin: 0, paddingBottom: 0 }}
                            //                                                    value={this.state.editAlarm?.ClrInput}
                            //                                                    onChange={this.handleAlarmSelectChange.bind(this)}
                            //                                                    >
                            //                                                        <MenuItem value="0">{intl.formatMessage({ id: 'Alarm Off' })}</MenuItem>
                            //                                                        {(this.state.channelsAvail & 0x01) != 0 &&
                            //                                                            <MenuItem value="1">{intl.formatMessage({ id: 'Flow A' })}</MenuItem>
                            //                                                        }
                            //                                                        {(this.state.channelsAvail & 0x01) != 0 &&
                            //                                                            <MenuItem value="21">{intl.formatMessage({ id: 'Consumption A' })}</MenuItem>
                            //                                                        }
                            //                                                        {(this.state.channelsAvail & 0x04) != 0 &&
                            //                                                            <MenuItem value="3">{intl.formatMessage({ id: 'Latest Pressure C' })}</MenuItem>
                            //                                                        }
                            //                                                        {(this.state.channelsAvail & 0x04) != 0 &&
                            //                                                            <MenuItem value="11">{intl.formatMessage({ id: 'Pressure C Difference' })}</MenuItem>
                            //                                                        }
                            //                                                        {(this.state.channelsAvail & 0x08) != 0 &&
                            //                                                            <MenuItem value="7">{intl.formatMessage({ id: 'Latest Pressure D' })}</MenuItem>
                            //                                                        }
                            //                                                        {(this.state.channelsAvail & 0x08) != 0 &&
                            //                                                            <MenuItem value="12">{intl.formatMessage({ id: 'Pressure D Difference' })}</MenuItem>
                            //                                                        }
                            //                                                        {(this.state.channelsAvail & 0x02) != 0 &&
                            //                                                            <MenuItem value="9">{intl.formatMessage({ id: 'Flow B' })}</MenuItem>
                            //                                                        }
                            //                                                        {(this.state.channelsAvail & 0x02) != 0 &&
                            //                                                            <MenuItem value="22">{intl.formatMessage({ id: 'Consumption B' })}</MenuItem>
                            //                                                        }
                            //                                                        <MenuItem value="30">{intl.formatMessage({ id: 'Signal Strength' })} (0-31)</MenuItem>
                            //                                                        <MenuItem value="31">{intl.formatMessage({ id: 'Battery' })} (mV)</MenuItem>
                            //                                                </Select>
                            //                                                </FormControl>
                            //                                            </TooltipMaterial>
                            //                                        </Grid>
                            //                                        <Grid item xs={3}>
                            //                                            <TooltipMaterial placement="top" title={intl.formatMessage({ id: "This sets the condition of how that alarm will be cleared from the level in the next box (e.g. Consumption 'IS GREATER THAN' 10 l/s )" })} >
                            //                                            <FormControl fullWidth>
                            //                                                    <InputLabel id="operator-select-label">{intl.formatMessage({ id: 'Clear Alarm Condition' })}</InputLabel>
                            //                                                <Select
                            //                                                    name="ClrOperator"
                            //                                                    label={intl.formatMessage({ id: 'Clear Alarm Condition' })}
                            //                                                    labelId="operator-select-label"
                            //                                                    size="small"
                            //                                                    style={{ margin: 0, paddingBottom: 0 }}
                            //                                                    value={this.state.editAlarm?.ClrOperator}
                            //                                                    onChange={this.handleAlarmSelectChange.bind(this)}
                            //                                                    >
                            //                                                    <MenuItem value="0">{intl.formatMessage({ id: 'Alarm Off' })}</MenuItem>
                            //                                                    <MenuItem value="1">{intl.formatMessage({ id: 'is Equal to' })}</MenuItem>
                            //                                                    <MenuItem value="2">{intl.formatMessage({ id: 'is Not Equal to' })}</MenuItem>
                            //                                                    <MenuItem value="3">{intl.formatMessage({ id: 'is Less than' })}</MenuItem>
                            //                                                    <MenuItem value="4">{intl.formatMessage({ id: 'is Greater than' })}</MenuItem>
                            //                                                    <MenuItem value="5">{intl.formatMessage({ id: 'is Less than or equal to' })}</MenuItem>
                            //                                                    <MenuItem value="6">{intl.formatMessage({ id: 'is Greater than or equal to' })}</MenuItem>
                            //                                                </Select>
                            //                                                </FormControl>
                            //                                            </TooltipMaterial>
                            //                                        </Grid>
                                                                   

                            //                                        <Grid item xs={2}>
                                                                   
                            //                                            <TooltipMaterial placement="top" title={intl.formatMessage({ id: "This sets the clear value for the alarm (e.g. Consumption is greater than '10')" })} >  
                            //                                                <div>
                            //                                                    <TextField name="ClrThreshold"
                            //                                                        label="Clear Alarm Level"
                            //                                                        fullWidth={true}
                            //                                                        variant="outlined"
                            //                                                        size="small"
                            //                                                        value={this.state.editAlarm?.ClrThresholdStr}
                            //                                                        onChange={this.handleAlarmTextfieldChange.bind(this)}
                            //                                                        error={this.state.fieldErrors.ClrThreshold}
                            //                                                        helperText={this.state.fieldErrors.ClrThreshold ? intl.formatMessage({ id: "Must be DECIMAL number" }) : ""}
                            //                                                    /> {/*{this.displayUnits(this.state.editAlarm?.ClrInput, this.state.clrUnits)}*/}
                            //                                                </div>
                            //                                            </TooltipMaterial>
                            //                                        </Grid>
                            //                                        <Grid item xs={1}>
                            //                                            <FormControl fullWidth>
        
                            //                                                <TextField value={this.state.editAlarm?.Unit }  size="small"/>

                            //                                            </FormControl>
                            //                                        </Grid>
                            //                                        <Grid item xs={3}>
                            //                                            <TooltipMaterial placement="top" title="Sets the interval of how long this metric must happen before alarm is cleared">
                            //                                                <FormControl fullWidth>
                            //                                                    <InputLabel id="timeframe-select-label">{intl.formatMessage({ id: 'Clear Alarm Timeframe' })}</InputLabel>
                            //                                                    <Select
                            //                                                        name="ClrCountStr"
                            //                                                        label="Set Alarm Timeframe"
                            //                                                        labelId="timeframe-select-label"
                            //                                                        size="small"
                            //                                                        style={{ margin: 0, paddingBottom: 0 }}
                            //                                                        value={this.state.editAlarm?.ClrCountStr}
                            //                                                        onChange={this.handleAlarmSelectChange.bind(this)}
                            //                                                    >
                            //                                                        <MenuItem value="5mins">{intl.formatMessage({ id: 'every' })} 5 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                            //                                                        <MenuItem value="15mins">{intl.formatMessage({ id: 'every' })} 15 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                            //                                                        <MenuItem value="30mins">{intl.formatMessage({ id: 'every' })} 30 {intl.formatMessage({ id: 'Minutes' })}</MenuItem>
                            //                                                        <MenuItem value="1hour">{intl.formatMessage({ id: 'every' })} {intl.formatMessage({ id: 'Hour' })}</MenuItem>
                            //                                                        <MenuItem value="3hour">{intl.formatMessage({ id: 'every' })} 3 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                            //                                                        <MenuItem value="6hour">{intl.formatMessage({ id: 'every' })} 6 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                            //                                                        <MenuItem value="12hour">{intl.formatMessage({ id: 'every' })} 12 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                            //                                                        <MenuItem value="24hour">{intl.formatMessage({ id: 'every' })} 24 {intl.formatMessage({ id: 'Hours' })}</MenuItem>
                            //                                                    </Select>
                            //                                                </FormControl>
                            //                                            </TooltipMaterial>
                            //                                        </Grid>
                                                                    
                            //                                        <Grid item xs={7}>
                            //                                            <TooltipMaterial placement="top" title={intl.formatMessage({ id: "Set the message for the alarm which will appear in the text messages set in the contact section" })} >
                            //                                                <TextField name="AlarmMessage" label={intl.formatMessage({ id: "Message" })} fullWidth={true} variant="outlined" size="small" value={this.state.editAlarm?.AlarmMessage} onChange={this.handleAlarmTextfieldChange.bind(this)} />
                            //                                        </TooltipMaterial>
                            //                                        </Grid>
                            //                                        <Grid item xs={2}>
                            //                                            {/*<TooltipMaterial title="Set severity of alarm to select how this alarm will be sent">*/}
                            //                                            <FormControl fullWidth>
                            //                                                <InputLabel id="operator-select-label">{intl.formatMessage({ id: "Severity" })}</InputLabel>
                            //                                                <Select
                            //                                                    name="AlarmClass"
                            //                                                    label="Severity"
                            //                                                    labelId="severity-select-label"
                            //                                                    size="small"
                            //                                                    style={{ margin: 0, paddingBottom: 0 }}
                            //                                                    value={this.state.editAlarm?.AlarmClass}
                            //                                                    onChange={this.handleAlarmSelectChange.bind(this)}
                            //                                                >
                            //                                                    <MenuItem value="0">{intl.formatMessage({ id: "Not set" })}</MenuItem>
                            //                                                    <MenuItem value="7">{intl.formatMessage({ id: "Low" })}</MenuItem>
                            //                                                    <MenuItem value="6">{intl.formatMessage({ id: "Normal" })}</MenuItem>
                            //                                                    <MenuItem value="5">{intl.formatMessage({ id: "High" })}</MenuItem>
                            //                                                    <MenuItem value="4" > {intl.formatMessage({ id: "Critical" })}</MenuItem>
                            //                                                </Select>
                            //                                                </FormControl>
                            //                                            {/*</TooltipMaterial>*/}
                            //                                        </Grid>
                            //                                        <Grid item xs={1}>
                            //                                            <TooltipMaterial placement="top" title={intl.formatMessage({ id: "Sets a limit on the amount of alarms that will be sent" })} >
                            //                                            <TextField name="MaxAlarms"
                            //                                                label={intl.formatMessage({ id: "Max Alarms per day" })}
                            //                                                fullWidth={false}
                            //                                                variant="outlined"
                            //                                                size="small"
                            //                                                value={this.state.editAlarm?.MaxAlarmsStr}
                            //                                                onChange={this.handleAlarmTextfieldChange.bind(this)}
                            //                                                error={this.state.fieldErrors.MaxAlarms}
                            //                                                    helperText={this.state.fieldErrors.MaxAlarms ? intl.formatMessage({ id: "Must be INTEGER number" }) : ""}
                            //                                                />
                            //                                            </TooltipMaterial>
                            //                                        </Grid>
                            //                                        <Grid item xs={2}>
                            //                                            <div style={{ display: "flex", justifyContent: "space-evenly", width: "100%" }}>
                                                                            
                            //                                                <Button variant="contained" style={{ marginRight: "10px" }} color="secondary" onClick={(): void => this.updateAlarm()}>{intl.formatMessage({ id: "Save" })}</Button>
                            //                                                <Button variant="contained" /*disabled={this.state.editAlarm?.Idx }*/ color="error" onClick={(): void => this.deleteAlarm(this.state.editAlarm?.Id)}>{intl.formatMessage({ id: "Delete" })}</Button>
                            //                                            </div>
                            //                                        </Grid>
                                                                    

                                
                            //                                    </Grid>
                            //                                </Box>
                            //                            </div>
                            //                        )
                            //                    },
                            //                ]}
                            //            />
                            //        </div>
                            //    )
                            //},
                            {
                                tabName: "Battery",
                                disabled: !this.state.ready,
                                tabContent: (<div>
                                    <p>{intl.formatMessage({ id: "Reset Battery Estimator" })}</p>
                                    <Button variant="contained" onClick={this.handleBatteryResetClick.bind(this)}>{this.state.batteryReset ? intl.formatMessage({ id: "Cancel" }) : intl.formatMessage({ id: "New Battery Added to Device" }) }</Button>
                                    <p>{intl.formatMessage({ id: "Sending this to the device will reset the battery life expectancy calculator and metrics for battery in all reports" })}</p>
                                </div>)
                            },
                            sessionStorage.getItem("userLevel") == "identityadmin" ?
                                {
                                    tabName: "Custom",
                                    disabled: !this.state.ready,
                                    tabContent: (
                                        <div>
                                            <p>{intl.formatMessage({ id: "Custom Settings" })}</p>
                                            <TextField
                                                id="generalUpdate"
                                                label={intl.formatMessage({ id: "Updates <reg>=xxx (one per line)" })}
                                                onChange={this.configUpdateChanged}
                                                variant="outlined"
                                                multiline
                                                fullWidth
                                            />
                                            <p>Request messages</p>
                                            {FW >= 2.99 ?
                                                <><Button variant="contained" onClick={this.handleConfigMessageRequestClick.bind(this)}>{this.state.configMessageRequest ? "Config Message Requested" : "Request CONFIG Message" }</Button>
                                                <p></p>
                                                <Button variant="contained" onClick={this.handleStatusMessageRequestClick.bind(this)}>{this.state.statusMessageRequest ? "Status Message Requested" : "Request STATUS Message"}</Button>
                                                    <p></p>
                                                    <Button variant="contained" onClick={this.handleSigCheckRequestClick.bind(this)}>{this.state.sigCheckRequest ? "Signal Check Requested" : "Request SIGNAL CHECK"}</Button>
                                                    <p></p>
                                                </>
                                                : null}
                                        </div>
                                    )
                                } : null,

                        ]}
                    />
                }
                {this.state.panel == "Save Config" &&
                    <Card>
                        <CardHeader color="primary" >
                            <div className={this.props.classes.cardTitleWhite} style={{ paddingLeft: "30px" }}>
                                <h4 className={this.props.classes.cardTitleWhite}>
                                    {intl.formatMessage({ id: "Save config for immediately or scheduled update" })}
                                </h4></div>
                        </CardHeader>
                        <CardBody>
                            <div style={{ paddingLeft: "30px", paddingTop: "20px" }}>
                                <LocalizationProvider dateAdapter={DateAdapter}>
                                    <DateTimePicker
                                        label={intl.formatMessage({ id: "Send Config After" })}
                                    value={this.state.sendAfter}
                                    onChange={this.handleSendAfterChange}
                                    renderInput={(params) => <TextField {...params} />}
                                    disabled={true}
                                    />
                                </LocalizationProvider>
                            </div>
                            {this.state.dormant && <TextField
                                label={`${intl.formatMessage({ id: "Type" })} INACTIVE ${intl.formatMessage({id: "to confirm turning device off" })}`}
                                variant="outlined"
                                size="medium"
                                style={{width: "50%"} }
                                value={this.state.confirmText}
                                onChange={(e):void => this.handleConfirmTextChange(e, 'inactive')}
                            />}
                            {this.state.batteryReset && <TextField
                                label={`${intl.formatMessage({ id: "Type" })} BATTERY ${intl.formatMessage({ id: 'to confirm that you have change the battery and want to reset the battery life calculator' })}` }
                                variant="outlined"
                                size="medium"
                                style={{ width: "50%" }}
                                value={this.state.confirmText}
                                onChange={(e):void => this.handleConfirmTextChange(e, 'battery')}
                            />}

                            <div style={{ paddingLeft: "30px", paddingTop: "20px" }}>
                                <Button variant="contained" color="primary" disabled={!this.state.allowConfig} onClick={(): void => this.handleSendAfterClick()}>{intl.formatMessage({ id: "Update immediately" })}</Button>&nbsp;
                                <Button variant="contained" color="primary" onClick={(): void => this.handleSendAfterClick()} disabled={this.state.sendAfter == null || this.state.allowConfig === false}>{intl.formatMessage({ id: "Update after scheduled Date/Time" })}</Button>&nbsp;
                                <Button variant="contained" color="secondary" onClick={(): void => this.setState({ panel: "Config" })}>{intl.formatMessage({ id: "Cancel" })}</Button>
                            </div>

                        </CardBody>
                    </Card>
                }
                <NotificationContainer />
            </div>
        );
    }

}

export default injectIntl(withStyles(style)(ToolkitCHR));